<template>
    <li v-if="message.type === 'system'" class="system-message-wrapper">
        <span class="system-message-text">
            <i class="ri-pushpin-fill me-1"></i> {{ message.systemText }}
        </span>
    </li>
    <li v-else class="msg_wpp_render" :class="[messageWrapperClasses, { 'reply-selected': isReplySelected }]"
        @click.stop.self="isForwarding && $emit('toggle-forward', selectionIds)"
        @dblclick.prevent="onDoubleClickReply"
        >

        <div v-if="isGroupContext && !message.isSent"
            class="group-chat-avatar-container"
            :class="{ 'd-none': isForwarding }">
            <img
                :src="senderAvatar || branding.images.avatarFallback"
                class="rounded-circle group-avatar-img cursor-pointer"
                :style="{ borderColor: senderBorderColor }"
                alt="Avatar"
                loading="lazy"
                @click.stop="handleGroupAvatarClick"
            >
        </div>
        <div class="conversation-list" :class="{ 'forward-mode': isForwarding }"
            @click.stop.self="isForwarding && $emit('toggle-forward', selectionIds)">
            <div v-if="isForwarding" class="message-selection-box" @click.stop="$emit('toggle-forward', selectionIds)">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" :checked="isForwardSelected" readonly />
                </div>
            </div>
            <div class="ctext-wrap" @click.stop.self="isForwarding && $emit('toggle-forward', selectionIds)"
                @mouseenter="isHovered = true" @mouseleave="isHovered = false">

                <Transition name="emoji-bar">
                    <div v-if="!message.isDeleted && !isForwarding && isHovered"
                        class="emoji-hover-bar" @click.stop>

                        <button v-for="emoji in popularEmojis" :key="emoji"
                            class="emoji-quick-btn" @click.stop="onEmojiSelect(emoji)">{{ emoji }}</button>

                        <button class="emoji-quick-btn emoji-more-btn"
                            @click.stop="isPickerOpen = !isPickerOpen"
                            title="Mais emojis">
                            <i class="ri-add-line"></i>
                        </button>

                        <div v-if="isPickerOpen" class="emoji-picker-wrapper" @click.stop>
                            <EmojiPicker
                                :native="true"
                                :hide-group-icons="false"
                                :disable-skin-tones="true"
                                theme="auto"
                                @select="onPickerEmojiSelect"
                            />
                        </div>

                    </div>
                </Transition>

                <div class="ctext-wrap-content" :class="{ 'deleted-content': message.isDeleted, 'is-failed-message': message.uploadError }">


                    <div v-if="message.isDeleted" class="deleted-notice mb-1">
                        <i class="ri-chat-delete-fill"></i>
                        <small>Deletada </small>
                    </div>

                    <div :class="{ 'opacity-50': message.isDeleted }">

                        <!-- Selo de encaminhamento, no padrão do WhatsApp: vale tanto para
                             mensagem que o atendente encaminhou daqui quanto para mensagem
                             que o cliente encaminhou pra nós (`contextInfo.isForwarded`). -->
                        <div v-if="message.ehEncaminhamento" class="status-reply-badge">
                            <i class="ri-share-forward-line"></i>
                            <span>Encaminhada</span>
                        </div>

                        <div v-if="message.ehRespostaStatus" class="status-reply-badge">
                            <i class="ri-contacts-book-2-line"></i>
                            <span>Respondeu ao seu status</span>
                        </div>

                        <!-- Contexto de story do Instagram. Menção: a mídia da
                             própria mensagem É o story, então só o selo. Resposta:
                             o story respondido vem como miniatura, senão o
                             atendente lê "amei" sem saber a quê. -->
                        <div v-if="message.isStoryMention" class="status-reply-badge">
                            <i class="ri-instagram-line"></i>
                            <span>Mencionou você no story</span>
                        </div>
                        <!-- Story que o CLIENTE compartilhou no direct. A mídia da
                             mensagem É o story, como na menção — muda só o rótulo,
                             porque "mencionou você" seria mentira aqui. -->
                        <div v-else-if="message.isStoryShare" class="status-reply-badge">
                            <i class="ri-instagram-line"></i>
                            <span>Compartilhou um story</span>
                        </div>
                        <!-- Publicação compartilhada QUE VEIO COM MÍDIA (o caso do
                             `ig_post`, cuja url já é o arquivo). A foto é desenhada
                             como qualquer outra logo abaixo; sem este selo ela chegava
                             como uma imagem qualquer, sem nada dizendo que veio de uma
                             publicação do Instagram. -->
                        <div v-else-if="compartilhamentoComMidia" class="status-reply-badge">
                            <i class="ri-instagram-line"></i>
                            <span>{{ rotuloCompartilhamento }}</span>
                            <span v-if="compartilhamentoTotalMidias" class="selo-contagem">
                                {{ compartilhamentoTotalMidias }} imagens
                            </span>
                        </div>
                        <div v-else-if="message.isStoryReply" class="d-flex flex-row align-items-center">
                            <div class="status-reply-badge flex-grow-1">
                                <i class="ri-instagram-line"></i>
                                <span>Respondeu ao seu story</span>
                            </div>
                            <div v-if="message.storyUrl" class="reply-media-content-preview">
                                <img :src="message.storyUrl" alt="Story respondido" style="object-fit: cover;"
                                     class="reply-media-content-preview"
                                     @click="uiStore.openMediaViewer(message.storyUrl, 'image', '')">
                            </div>
                        </div>

                        <!-- Anúncio CTWA que originou o lead: o cliente clicou em
                             "Enviar mensagem" num anúncio do Instagram/Facebook. Só a
                             PRIMEIRA mensagem dele carrega isso, e é o único lugar onde
                             o atendente descobre qual produto foi divulgado. -->
                        <component v-if="message.anuncio"
                            :is="anuncioUrl ? 'a' : 'div'"
                            class="ad-card"
                            :class="{ 'ad-card-clickable': !!anuncioUrl }"
                            :title="anuncioTooltip"
                            v-bind="anuncioUrl ? { href: anuncioUrl, target: '_blank', rel: 'noopener noreferrer' } : {}">
                            <img v-if="anuncioThumb" :src="anuncioThumb" class="ad-card-thumb"
                                 alt="Criativo do anúncio" loading="lazy" @error="anuncioThumbQuebrada = anuncioThumb">
                            <!-- Sem criativo (ou thumb da Meta já expirada) o card não pode
                                 ficar com um buraco: o ícone da rede segura o layout. -->
                            <div v-else class="ad-card-thumb ad-card-thumb-empty">
                                <i :class="anuncioIcone"></i>
                            </div>
                            <div class="ad-card-content">
                                <div class="ad-card-source">
                                    <i :class="anuncioIcone"></i>
                                    <span>{{ anuncioSelo }}</span>
                                    <i v-if="anuncioUrl" class="ri-external-link-line ad-card-link-icon"></i>
                                </div>
                                <div v-if="message.anuncio.titulo" class="ad-card-title">{{ message.anuncio.titulo }}</div>
                                <div v-if="message.anuncio.corpo" class="ad-card-text">{{ message.anuncio.corpo }}</div>
                            </div>
                        </component>

                        <div class=" d-flex flex-row" v-if="message.replyToId">
                            <!-- Citada de GRUPO ("Responder em particular"): não está nesta conversa, então o clique não tem para onde rolar. -->
                            <div class="quoted-reply-wrapper" :class="{'please-match-with-your-sibling': ['imagem','video'].includes(message.replyType ?? ''), 'quoted-reply-grupo': !!message.replyGrupoNome}" @click="!message.replyGrupoNome && uiStore.scrollToMessage(message.replyToId)">
                                <div class="quoted-content">
                                    <div class="quoted-owner">{{ message.replyOwner || chatStore.messagesById.get(message.replyToId)?.agentName }}</div>
                                    <div v-if="message.replyGrupoNome" class="quoted-group-origin text-truncate" :title="`do grupo ${message.replyGrupoNome}`">
                                        <i class="ri-group-line me-1" aria-hidden="true"></i>do grupo {{ message.replyGrupoNome }}
                                    </div>
                                    <div class="quoted-snippet">
                                        <!-- Verifica se a mensagem respondida é mídia/áudio -->
                                        <div v-if="getReplyMediaIcon(message.replyType)" class="reply-media-preview">
                                            <i :class="getReplyMediaIcon(message.replyType)"></i>
                                            <span>{{ message.replyText }}</span>
                                            <!-- <span>{{ getReplyMediaLabel() }}</span> -->
                                        </div>
                                        <!-- Se for texto normal -->
                                        <div v-else>{{ message.replyText }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="message.replyType == 'imagem' && message.replyUrl" class="reply-media-content-preview">
                                <img :src="message.replyUrl" style="object-fit: cover;" class="reply-media-content-preview">
                            </div>
                            <div v-else-if="message.replyType == 'video' && message.replyUrl" class="reply-media-content-preview">
                                <VideoDeChat :src="message.replyUrl" style="object-fit: cover;" class="reply-media-content-preview"></VideoDeChat>
                            </div>
                            <!-- Citada respondida enquanto a mídia dela estava pendente: só há a miniatura. -->
                            <div v-else-if="message.replyMiniatura" class="reply-media-content-preview">
                                <img :src="message.replyMiniatura" style="object-fit: cover;" class="reply-media-content-preview">
                            </div>
                            <!-- <div v-else-if="message.replyType == 'file'" class="reply-media-content-preview">

                            </div>
                            <div v-else-if="message.replyType == 'audio'" class="reply-media-content-preview">

                            </div> -->
                        </div>

                        <div v-if="!message.isSent && !message.isBot && message.sender && isGroupContext"
                            class="group-sender-name mb-1"
                            :style="{ color: senderBorderColor }">
                            <i class="ri-account-circle-fill me-2"></i>{{ resolvedSenderName }}
                        </div>

                        <div v-if="message.agentName" class="agent-name-header">
                            <i class="ri-account-circle-fill me-1"></i>{{ message.agentName }}
                        </div>

                        <!-- Mídia que só existe na CDN da Meta e cujo prazo (~24h) já passou.
                             PRIMEIRO desta cadeia de propósito: é a cadeia que desenha a
                             mídia, e o aviso precisa SUBSTITUIR o player/placeholder, não
                             aparecer junto dele. Sem isto a bolha mostrava "Carregando
                             mídia…" e o aviso de expirado ao mesmo tempo. -->
                        <div v-if="message.midiaExpirada" class="media-perdida-card">
                            <i class="ri-time-line media-perdida-icon"></i>
                            <span class="media-perdida-text">Este story expirou e não está mais disponível no Instagram.</span>
                        </div>

                        <div v-else-if="isPixMessage()" class="template-card pix-style">
                            <div class="card-header-accent"></div>
                            <div class="card-body-content">
                                <div class="pix-title-row">
                                    <i class="ri-pix-fill pix-icon-brand"></i>
                                    <span class="pix-label">Transferência Pix</span>
                                </div>
                                <div class="pix-details">
                                    <div v-if="pixCampos.titular" class="detail-group">
                                        <label>Titular</label>
                                        <p class="text-truncate">{{ pixCampos.titular }}</p>
                                    </div>
                                    <div v-if="pixCampos.valor" class="detail-group">
                                        <label>Valor</label>
                                        <p class="text-truncate">{{ pixCampos.valor }}</p>
                                    </div>
                                    <div class="detail-group">
                                        <label>Chave</label>
                                        <div class="key-container">
                                            <span class="key-text text-truncate">{{ pixCampos.chave }}</span>
                                        </div>
                                    </div>
                                    <div v-if="pixCampos.corpo" class="detail-group">
                                        <label>Descrição</label>
                                        <p class="pix-corpo">{{ pixCampos.corpo }}</p>
                                    </div>
                                </div>
                                <button class="btn-action-pix" @click.stop="copyData(pixCampos.chave)">
                                    <i class="ri-file-copy-line me-1"></i> Copiar Chave Pix
                                </button>
                            </div>
                        </div>

                        <div v-else-if="isPasswordMessage()" class="template-card pass-style">
                            <div class="pass-icon-circle"><i class="ri-shield-keyhole-fill"></i></div>
                            <h6 class="pass-title">Senha de Acesso</h6>
                            <p class="pass-desc">Utilize o código abaixo para validar seu acesso.</p>
                            <div class="code-display" @click.stop="copyData(extractData('Código:'))">
                                {{ extractData('Código:') }} <i class="ri-file-copy-line copy-icon"></i>
                            </div>
                            <div class="pass-footer">Esta senha expira em breve.</div>
                        </div>

                        <div v-else-if="(message as any).type === 'media_grid'" class="media-grid-container">
                            <div class="media-grid-wrapper">
                                <div
                                    v-for="(subMsg, index) in ((message as any).gridMessages).slice(0, 4)"
                                    :key="subMsg.id"
                                    class="grid-item"
                                    @click.stop="openGridMedia(subMsg, Number(index))"
                                >
                                    <img
                                        v-if="subMsg.fileData?.mimeType.startsWith('image/')"
                                        :src="subMsg.fileData.url"
                                        class="grid-img"
                                        loading="lazy"
                                    />
                                    <VideoDeChat
                                        v-else-if="subMsg.fileData?.mimeType.startsWith('video/')"
                                        :src="subMsg.fileData.url"
                                        class="grid-img"
                                        muted
                                        preload="metadata"
                                    ></VideoDeChat>

                                    <div
                                        v-if="index === 3 && ((message as any).gridMessages).length > 4"
                                        class="grid-overlay"
                                    >
                                        <span>+{{ ((message as any).gridMessages).length - 3 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!--
                            Mídia ainda no reparo assíncrono do servidor: a mensagem já existe, a
                            mídia chega por `MENSAGEM.MIDIA`. Miniatura quando o WhatsApp mandou
                            uma; senão, placeholder. Sem abrir/baixar até a mídia chegar.
                        -->
                        <div
                            v-else-if="message.midiaPendente && ['file', 'imagem', 'video', 'sticker', 'audio'].includes(message.type)"
                            class="midia-pendente"
                            :class="{ 'midia-pendente--audio': message.type === 'audio' }"
                        >
                            <div class="midia-pendente__visual">
                                <img v-if="message.miniatura" :src="message.miniatura" class="midia-pendente__miniatura" alt="" />
                                <div class="midia-pendente__carregando">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span>Carregando mídia…</span>
                                </div>
                            </div>
                            <div v-if="message.legenda" class="midia-pendente__legenda">{{ message.legenda }}</div>
                        </div>

                        <ChatMessageMedia v-else-if="message.type === 'file' || message.type === 'imagem' || message.type === 'video' || message.type === 'sticker'" :message="message" @retry:failed-message="chatStore.retryFailedMessage" />

                        <ChatTemplateMeta v-else-if="message.type === 'template_meta'" :message="message" />

                        <div v-else-if="message.type === 'contact'" class="contact-card-premium">
                            <div class="premium-card-body">
                                <div class="avatar-area">
                                    <div class="single-avatar">
                                        <img v-if="message.contactData?.at(0)?.avatar || chatStore.contatosByCodigo.get(message.contactData?.at(0)?.phone || '')"
                                            :src="message.contactData?.at(0)?.avatar || chatStore.contatosByCodigo.get(message.contactData?.at(0)?.phone || '')?.imagem"
                                            class="img-fluid object-fit-cover w-100 h-100">
                                        <span v-else class="initials">
                                            {{ message.contactData?.at(0)?.initials || 'C' }}
                                        </span>
                                    </div>
                                </div>

                                <div class="contact-info-col">
                                    <h6 class="primary-name text-truncate">
                                        {{ message.contactData?.at(0)?.name || 'Contato Desconhecido' }}
                                    </h6>
                                    <span class="secondary-text text-truncate">
                                        {{ message.contactData?.at(0)?.phone || 'Sem número' }}
                                    </span>
                                </div>
                            </div>

                            <div class="premium-card-footer" @click.stop="chatStore.handleClickOnTextWithAction('phone', message.contactData?.at(0)?.phone, message.contactData?.at(0)?.name)">

                                <span class="btn-label">Conversar</span>
                                <i class="ri-message-3-line action-icon"></i>
                            </div>
                        </div>

                        <!-- Publicação do Instagram (post/reel) compartilhada: a Meta
                             manda o PERMALINK, não um arquivo. Quando o servidor não
                             consegue re-hospedar mídia de verdade, é este cartão que
                             aparece — antes o permalink era baixado e a mensagem virava
                             um anexo binário com um HTML dentro.
                             `v-else-if` (não `v-if`): um `v-if` aqui abria uma SEGUNDA
                             cadeia e a bolha desenhava o cartão Pix/Senha da cadeia de
                             cima E o bloco genérico de lista daqui de baixo. -->
                        <component
                            v-else-if="message.compartilhamento && !compartilhamentoComMidia"
                            :is="compartilhamentoUrl ? 'a' : 'div'"
                            class="ad-card"
                            :class="{ 'ad-card-clickable': !!compartilhamentoUrl }"
                            v-bind="compartilhamentoUrl ? { href: compartilhamentoUrl, target: '_blank', rel: 'noopener noreferrer' } : {}">
                            <!-- Capa do reel quando a Graph respondeu; senão o ícone
                                 segura o layout (o permalink do Instagram não entrega
                                 miniatura nenhuma sem autenticação). -->
                            <img v-if="message.compartilhamento.capaUrl"
                                 :src="message.compartilhamento.capaUrl"
                                 class="ad-card-thumb" alt="Capa da publicação" loading="lazy">
                            <div v-else class="ad-card-thumb ad-card-thumb-empty">
                                <i class="ri-instagram-line"></i>
                            </div>
                            <div class="ad-card-content">
                                <div class="ad-card-source">
                                    <i class="ri-instagram-line"></i>
                                    <span>{{ rotuloCompartilhamentoCurto }}</span>
                                    <span v-if="compartilhamentoTotalMidias" class="ad-card-contagem">{{ compartilhamentoTotalMidias }} imagens</span>
                                    <i v-if="compartilhamentoUrl" class="ri-external-link-line ad-card-link-icon"></i>
                                </div>
                                <div v-if="message.compartilhamento.titulo" class="ad-card-text">{{ message.compartilhamento.titulo }}</div>
                            </div>
                        </component>
                        <div
                            v-else-if="message.ehMediaPerdida"
                            class="media-perdida-card"
                        >
                            <i class="ri-image-off-line media-perdida-icon"></i>
                            <span class="media-perdida-text">{{ message.text || 'Um arquivo de mídia foi recebido, mas não pôde ser carregado.' }}</span>
                        </div>
                        <div
                            v-else-if="message.type === 'view-once'"
                            class="media-perdida-card view-once-card"
                        >
                            <i class="ri-eye-off-line media-perdida-icon"></i>
                            <span class="media-perdida-text">Mensagem de visualização única. Abra o WhatsApp no celular para visualizá-la.</span>
                        </div>
                        <!-- Tipo que a Cloud API não representa (`unsupported`,
                             erro 131051). A mensagem EXISTE na conversa do
                             cliente; antes virava GENERICA e desenhava uma
                             bolha VAZIA, sem o operador saber que algo chegou.
                             O motivo da Meta entra no title, não no corpo: é
                             texto em inglês, serve para suporte e não para o
                             operador. -->
                        <div
                            v-else-if="message.type === 'unsupported'"
                            class="media-perdida-card nao-suportada-card"
                            :title="motivoNaoSuportada"
                        >
                            <i class="ri-error-warning-line media-perdida-icon"></i>
                            <span class="media-perdida-text">Mensagem de um tipo que o WhatsApp não suporta. Abra o WhatsApp no celular para visualizá-la.</span>
                        </div>
                        <ChatMessageText v-else-if="message.type === 'text' || message.type === 'list-answer'" :message="message" :highlightQuery="highlightQuery" />

                        <div v-else-if="message.type === 'list' && message.listInline" class="interactive-buttons-message">
                            <p v-if="message.listHeader" class="mb-2 message-text" v-html="formattedListHeader"></p>
                            <div class="interactive-buttons">
                                <div v-for="(option, idx) in message.listOptions" :key="option.id || idx"
                                    class="bot-list-button"
                                    :class="{ 'is-display-only': !isActionableButton(option) }"
                                    @click.stop="onInteractiveButtonClick(option)">
                                    <i v-if="option.actionType === 'COPIA'" class="ri-file-copy-line me-1"></i>
                                    <i v-else-if="option.actionType === 'URL'" class="ri-external-link-line me-1"></i>
                                    <i v-else-if="option.actionType === 'LIGACAO'" class="ri-phone-line me-1"></i>
                                    {{ option.text }}
                                </div>
                            </div>
                        </div>

                        <div v-else-if="message.type === 'list'">
                            <p class="mb-2 message-text" v-html="formattedListHeader"></p>
                            <div class="bot-list-button" @click.stop="openListModal(message)">
                                <i class="ri-list-check me-1"></i>
                                {{ message.listButtonText || 'Ver opções' }}
                            </div>
                        </div>

                        <div v-else-if="message.type === 'location'" class="location-message-card">
                            <div class="location-preview">
                                <iframe
                                    width="100%"
                                    height="180"
                                    frameborder="0"
                                    scrolling="no"
                                    marginheight="0"
                                    marginwidth="0"
                                    :src="`https://maps.google.com/maps?q=${message.location?.lat},${message.location?.lng}&hl=pt&z=14&amp;output=embed`"
                                >
                                </iframe>
                                <a :href="`https://maps.google.com/maps?q=${message.location?.lat},${message.location?.lng}`"
                                target="_blank"
                                class="location-overlay">
                                </a>
                            </div>
                            <div class="location-footer" @click="openMapExternal(message.location?.lat, message.location?.lng)">
                                <i class="ri-map-pin-2-fill text-danger me-2"></i>
                                <span>Localização em tempo real</span> </div>
                        </div>

                        <div v-else-if="message.type === 'event'" class="contact-card-premium">
                            <div class="premium-card-body">
                                <div class="avatar-area">
                                    <div class="single-avatar event-avatar">
                                        <i class="ri-calendar-event-fill"></i>
                                    </div>
                                </div>

                                <div class="contact-info-col">
                                    <h6 class="primary-name text-truncate" style="white-space: normal; line-height: 1.3;">
                                        {{ message.eventData?.name || message.text || 'Convite para Evento' }}
                                    </h6>

                                    <span class="secondary-text" style="white-space: normal;" v-if="message.eventData?.startTime">
                                        {{ message.eventData.startTime }}
                                        <template v-if="message.eventData?.endTime"> a {{ message.eventData.endTime }}</template>
                                    </span>
                                    <span class="secondary-text" style="white-space: normal;" v-else-if="message.text && message.text !== '📆 Evento'">
                                        {{ message.text }}
                                    </span>

                                    <span class="secondary-text" style="white-space: normal;" v-if="message.eventData?.description">
                                        {{ message.eventData.description }}
                                    </span>

                                    <span class="secondary-text" style="white-space: normal; display: flex; align-items: flex-start; gap: 4px;" v-if="message.eventData?.location">
                                        <i class="ri-map-pin-line mt-1"></i> {{ message.eventData.location }}
                                    </span>
                                    <span class="secondary-text" style="white-space: normal; display: flex; align-items: center; gap: 4px;" v-if="message.eventData?.joinLink">
                                        <i class="ri-links-line"></i> {{ message.eventData.joinLink }}
                                    </span>
                                    <span class="badge bg-danger mt-1 align-self-start" v-if="message.eventData?.isCanceled">Evento Cancelado</span>
                                </div>
                            </div>

                            <div class="premium-card-footer" style="justify-content: flex-start; gap: 8px;">
                                <img v-if="senderAvatar" :src="senderAvatar" class="rounded-circle" style="width: 20px; height: 20px; object-fit: cover;">
                                <i v-else class="ri-user-line" style="font-size: 14px; color: var(--bs-primary);"></i>
                                <span class="btn-label" style="font-size: 12px; font-weight: 500;">
                                    {{ message.eventData?.guestCount ? `Presença confirmada: ${message.eventData.guestCount}` : 'Visualizar evento no celular' }}
                                </span>
                            </div>
                        </div>

                        <div v-else-if="message.type === 'group-invite'" class="group-invite-card">
                            <div class="gi-header">
                                <div class="gi-icon-wrap">
                                    <i class="ri-group-fill gi-icon"></i>
                                </div>
                                <div class="gi-header-text">
                                    <span class="gi-label">Grupo do WhatsApp</span>
                                    <h6 class="gi-group-name">{{ message.groupInviteData?.nomeGrupo || 'Convite para grupo' }}</h6>
                                </div>
                            </div>
                            <div class="gi-body" v-if="message.groupInviteData?.caption">
                                <p class="gi-caption">{{ message.groupInviteData.caption }}</p>
                            </div>
                            <div class="gi-footer">
                                <i class="ri-information-line gi-info-icon"></i>
                                <span class="gi-info-text">Abra o WhatsApp no seu dispositivo para entrar neste grupo</span>
                            </div>
                        </div>

                        <!--
                            Pedido do catálogo do WhatsApp. `catalogOrderData` é
                            lido do `conteudo`, não do tipo, então este card
                            também desenha o histórico gravado como GENERICA.
                            A miniatura já vem embutida no payload — não há
                            download de mídia nenhum aqui.
                        -->
                        <div v-else-if="message.type === 'catalog-order'" class="catalog-order-card">
                            <div class="co-media" v-if="message.catalogOrderData?.thumbnailDataUrl">
                                <img :src="message.catalogOrderData.thumbnailDataUrl" alt="" />
                                <span class="co-surface">Catálogo</span>
                            </div>
                            <div class="co-body">
                                <div class="co-label">Pedido do catálogo</div>
                                <!--
                                    Só o transporte do baileys manda nome de
                                    produto. Pela Cloud API oficial não vem nome
                                    nenhum: ali a lista de itens abaixo é que
                                    identifica o pedido, e inventar um título
                                    genérico só empurraria a informação real
                                    para baixo.
                                -->
                                <h6 class="co-title" v-if="message.catalogOrderData?.titulo">{{ message.catalogOrderData.titulo }}</h6>
                                <div class="co-meta" v-if="message.catalogOrderData?.totalFormatado || message.catalogOrderData?.itemCount">
                                    <span class="co-price" v-if="message.catalogOrderData?.totalFormatado">{{ message.catalogOrderData.totalFormatado }}</span>
                                    <span class="co-dot" v-if="message.catalogOrderData?.totalFormatado && message.catalogOrderData?.itemCount">·</span>
                                    <span class="co-qty" v-if="message.catalogOrderData?.itemCount">
                                        {{ message.catalogOrderData.itemCount }} {{ message.catalogOrderData.itemCount === 1 ? 'item' : 'itens' }}
                                    </span>
                                </div>
                                <!--
                                    Itens do pedido — só o transporte oficial da
                                    Meta os manda. Sem nome de produto, o SKU é o
                                    único identificador disponível.
                                -->
                                <ul class="co-itens" v-if="message.catalogOrderData?.itens?.length">
                                    <li v-for="(item, i) in message.catalogOrderData.itens" :key="item.sku || i" class="co-item">
                                        <span class="co-item-sku">{{ item.sku || 'Item sem código' }}</span>
                                        <span class="co-item-qtd" v-if="item.quantidade">{{ item.quantidade }}×</span>
                                        <span class="co-item-preco" v-if="item.precoUnitarioFormatado">{{ item.precoUnitarioFormatado }}</span>
                                    </li>
                                </ul>

                                <!-- Nota livre que o comprador digitou junto do pedido. Quase sempre vazia. -->
                                <p class="co-note" v-if="message.catalogOrderData?.mensagem">{{ message.catalogOrderData.mensagem }}</p>
                                <span class="co-status" v-if="message.catalogOrderData?.status === 'INQUIRY'">
                                    <i class="ri-question-line"></i> Aguardando resposta
                                </span>
                            </div>
                            <div class="co-footer">
                                <i class="ri-information-line co-info-icon"></i>
                                <span class="co-info-text">Abra o WhatsApp no celular para ver o pedido completo</span>
                            </div>
                        </div>

                        <div v-else-if="message.type === 'poll'" class="poll-message-card">
                            <h6 class="poll-question">{{ message.pollData?.question }}</h6>
                            <span class="poll-subtitle">{{ message.pollData?.allowMultiple ? 'Selecione uma ou mais opções' : 'Selecione uma opção' }}</span>

                            <div class="poll-options-list">
                                <div v-for="(option, idx) in message.pollData?.options" :key="idx" class="poll-option-item">
                                    <div class="poll-checkbox">
                                        <i class="ri-prohibited-2-line text-white"></i>
                                    </div>
                                    <div class="poll-bar-container">
                                        <div class="poll-label-row">
                                            <span class="poll-opt-text">{{ option.text }}</span>
                                            <!-- Gatilho de "quem votou": os avatares dos primeiros
                                                 votantes ao lado da contagem. A contagem sozinha era
                                                 clicável e ninguém descobria — cara de texto, não de
                                                 controle. Rosto ao lado do número anuncia que há gente
                                                 por trás dele. Só existe quando há voto: popover vazio é
                                                 clique que não responde nada. -->
                                            <VDropdown v-if="pollVotersPorOpcao[idx]?.votes > 0" :distance="8" placement="top-end" :triggers="['click']">
                                                <!-- O rótulo acessível repete a CONTAGEM: `aria-label`
                                                     substitui o nome acessível do botão, e sem ela o
                                                     leitor de tela ouviria só a ação e perderia o número,
                                                     que é a informação principal. -->
                                                <button type="button" class="poll-opt-votes-btn" @click.stop
                                                        aria-haspopup="true"
                                                        :aria-label="`${pollVotersPorOpcao[idx].votes} ${pollVotersPorOpcao[idx].votes === 1 ? 'voto' : 'votos'} em ${option.text}. Ver quem votou`">
                                                    <span class="poll-voters-inline">
                                                        <template v-for="voter in pollVotersPorOpcao[idx].preview" :key="voter.key">
                                                            <AvatarField v-if="voter.avatar" :foto="voter.avatar" class="poll-voter-chip" />
                                                            <span v-else-if="voter.initials" class="poll-voter-chip poll-voter-chip-initials"
                                                                  :style="{ backgroundColor: pastelColorFromString(voter.label) }">
                                                                {{ voter.initials }}
                                                            </span>
                                                            <span v-else class="poll-voter-chip poll-voter-chip-blank">
                                                                <i class="ri-user-line"></i>
                                                            </span>
                                                        </template>
                                                        <!-- Excedente do que não caber na pilha, contando
                                                             também o voto ao vivo ainda sem votante. -->
                                                        <span v-if="pollVotersPorOpcao[idx].overflow > 0" class="poll-voter-chip poll-voter-chip-more">
                                                            +{{ pollVotersPorOpcao[idx].overflow }}
                                                        </span>
                                                    </span>
                                                    <span class="poll-opt-votes">{{ pollVotersPorOpcao[idx].votes }}</span>
                                                </button>
                                                <template #popper>
                                                    <div class="poll-voters-popper">
                                                        <div class="poll-voters-title">
                                                            {{ pollVotersPorOpcao[idx].votes }} {{ pollVotersPorOpcao[idx].votes === 1 ? 'voto' : 'votos' }} em "{{ option.text }}"
                                                        </div>
                                                        <PollVotersList :voters="pollVotersPorOpcao[idx].voters" :unnamed-votes="pollVotersPorOpcao[idx].unnamedVotes" />
                                                    </div>
                                                </template>
                                            </VDropdown>
                                            <span v-else class="poll-opt-votes">{{ option.votes || 0 }}</span>
                                        </div>
                                        <!-- Barra proporcional à opção MAIS votada, não ao total de
                                             votantes: em enquete de múltipla escolha a soma das opções
                                             passa do número de votantes, e a barra estouraria os 100%. -->
                                        <div class="poll-bar-track">
                                            <div class="poll-bar-fill" :style="{ width: pollBarWidth(message.pollData, option.votes) }"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Rodapé: o total e um "Ver votos" explícito, que abre a lista
                                 de TODAS as opções de uma vez. É a saída para quem não
                                 associa o avatar da opção a um clique, e a única forma de ler
                                 a enquete inteira sem abrir um popover por opção.
                                 O rodapé aparece com QUALQUER sinal de voto, e o botão é
                                 gated separado: `totalVoters` sai de `conteudo.votos` e as
                                 contagens saem de `conteudo.votosContagem`, chaves DIFERENTES
                                 que discordam nos dois sentidos — enquete anterior ao mapa de
                                 votantes tem contagem sem `votos` (e perderia o rodapé
                                 inteiro, justo onde o avatar já está degradado a "+N"), e
                                 `votosContagem` ilegível abriria um popover vazio. -->
                            <div v-if="(message.pollData?.totalVoters ?? 0) > 0 || pollVotersComVoto.length > 0" class="poll-footer-votes">
                                <!-- O total é de GENTE, e só `conteudo.votos` sabe quantas
                                     são. Somar `votosContagem` daria número errado em
                                     múltipla escolha, onde um votante soma em cada opção
                                     que marcou — melhor não afirmar do que afirmar torto. -->
                                <span v-if="(message.pollData?.totalVoters ?? 0) > 0" class="poll-total-voters">
                                    {{ message.pollData?.totalVoters }} {{ message.pollData?.totalVoters === 1 ? 'voto' : 'votos' }}
                                </span>
                                <span v-else></span>
                                <VDropdown v-if="pollVotersComVoto.length > 0" :distance="8" placement="top-end" :triggers="['click']">
                                    <button type="button" class="poll-see-votes-btn" @click.stop aria-haspopup="true">
                                        Ver votos<i class="ri-arrow-right-s-line"></i>
                                    </button>
                                    <template #popper>
                                        <div class="poll-voters-popper poll-voters-popper-todas">
                                            <div v-for="grupo in pollVotersComVoto" :key="grupo.key" class="poll-voters-group">
                                                <div class="poll-voters-title">
                                                    {{ grupo.votes }} {{ grupo.votes === 1 ? 'voto' : 'votos' }} em "{{ grupo.text }}"
                                                </div>
                                                <PollVotersList :voters="grupo.voters" :unnamed-votes="grupo.unnamedVotes" />
                                            </div>
                                        </div>
                                    </template>
                                </VDropdown>
                            </div>

                        </div>

                        <div v-else-if="message.type === 'multi_contact'" class="multi-contact-card">
                            <div class="multi-contact-body">

                                <div class="avatars-area">
                                    <div class="avatar-stack-wrapper">
                                        <div
                                            v-for="(contact, idx) in message.contactData?.slice(0, 3)"
                                            :key="idx"
                                            class="stack-avatar"
                                            :class="{'has-image': !!contact.avatar}"
                                            :style="{ zIndex: 3 - idx }"
                                        >
                                            <img v-if="contact.avatar || chatStore.contatosByCodigo.get(contact.phone)?.imagem" :src="contact.avatar || chatStore.contatosByCodigo.get(contact.phone)?.imagem" class="img-fluid">
                                            <span v-else class="initials">{{ contact.initials || 'C' }}</span>
                                        </div>
                                        <div v-if="(message.contactData?.length || 0) > 3" class="stack-avatar counter" style="z-index: 0;">
                                            <span>+{{ (message.contactData?.length || 0) - 3 }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="contact-info-col">
                                    <h6 class="primary-name text-truncate">
                                        {{ message.contactData?.[0]?.name || 'Contato Desconhecido' }}
                                    </h6>
                                    <span class="secondary-text text-truncate">
                                        {{ (message.contactData?.length || 1) > 1
                                            ? `e mais ${(message.contactData?.length || 1) - 1} contatos`
                                            : 'Contato compartilhado' }}
                                    </span>
                                </div>
                            </div>

                            <div class="multi-contact-footer" @click.stop="uiStore.openContactListModal(message.contactData ?? [])">
                                <span class="btn-label">Ver lista completa</span>
                                <i class="ri-arrow-right-s-line arrow-icon"></i>
                            </div>
                        </div>

                        <ChatMessageAudio v-else-if="message.type === 'audio'"
                            :audioUrl="message.audioUrl!"
                            :duration="message.audioDuration!"
                            :isSent="message.isSent"
                            :isDeleted="message.isDeleted"  :avatarUrl="senderAvatar || undefined"
                            :waveform="message.waveform" />
                    </div>

                    <div class="reactions-wrapper align-items-center" v-if="message.reactions && computedReactions.length > 0">
                        <span v-for="(countedEmoji, index) in computedReactions" :key="index" class="reaction-item"
                        >
                            <!-- @click="onEmojiSelect(emoji)" -->
                            {{ countedEmoji.emoji }}
                        </span>

                    </div>

                    <!-- Recusa de envio de QUALQUER tipo. O ícone vermelho sozinho não
                         distingue janela fechada de mídia rejeitada pela Meta, e o motivo
                         já chega do servidor em `conteudo.erro`. `template_meta` fica de
                         fora: `ChatTemplateMeta` desenha o próprio bloco de falha. -->
                    <FalhaEnvioMeta v-if="cMostrarMotivoFalha"
                        :codigo="message.erroCodigo" :motivo="message.motivoFalha" :detalhe="message.erroDetalhe" />

                    <div class="audio-meta-row" v-if="message.type === 'audio'">
                        <span class="chat-time-stamp">
                            <i v-if="message.isFavorite" class="ri-star-fill favorite-star-icon"></i>
                            <i v-if="message.isPinned" class="ri-pushpin-fill pinned-icon ms-1"></i>
                            <span v-if="message.isSent" class="ack me-1">
                                <i v-if="message.isDeleted" class="ri-prohibited-line text-danger ms-1" title="Apagada"></i>

                                <i v-else-if="message.readStatus === 'error'" class="ri-error-warning-line text-danger" :title="message.motivoFalha || 'Não enviado'"></i>
                                <i v-else-if="message.readStatus === 'sent'" class="ri-check-line"></i>
                                <i v-else-if="message.readStatus === 'read'" class="ri-check-double-line status-read"></i>
                                <i v-else-if="message.readStatus === 'delivered'" class="ri-check-double-line"></i>
                                <i v-else class="ri-time-line text-muted"></i>
                            </span>
                            <span class="align-middle">{{ formatTime(message.time) }}</span>
                            <small v-if="message.isEdited" class="edited-badge ms-2">(editado)</small>
                        </span>
                        <button type="button"
                            class="btn btn-link btn-sm btn-download-audio" title="Baixar áudio"
                            @click.stop="downloadAudio(message.audioUrl)">
                            <i class="ri-download-2-line"></i>
                        </button>
                    </div>

                    <p class="chat-time mb-0" v-if="message.type !== 'audio'">
                        <i v-if="message.isFavorite" class="ri-star-fill favorite-star-icon"></i>
                        <i v-if="message.isPinned" class="ri-pushpin-fill pinned-icon ms-1"></i>
                        <span v-if="message.isSent" class="ack me-1">
                            <i v-if="message.isDeleted" class="ri-prohibited-line text-danger ms-1" title="Apagada"></i>
                            <!-- `error`: a plataforma recusou o envio. O relógio de "enviando"
                                 nesse caso mente, e o motivo da recusa vive na bolha. -->
                            <i v-else-if="message.readStatus === 'error'" class="ri-error-warning-line text-danger" :title="message.motivoFalha || 'Não enviado'"></i>
                            <i v-else-if="message.readStatus === 'sent'" class="ri-check-line"></i>
                            <i v-else-if="message.readStatus === 'read'" class="ri-check-double-line status-read"></i>
                            <i v-else-if="message.readStatus === 'delivered'" class="ri-check-double-line"></i>
                            <i v-else class="ri-time-line text-muted"></i>
                        </span>
                        <span class="align-middle">{{ formatTime(message.time) }}</span>
                        <small v-if="message.isEdited" class="edited-badge ms-2">(editado)</small>
                    </p>
                </div>

                <DropdownField
                    class="align-self-start"
                    :distance="6"
                    placement="bottom-end"
                    strategy="fixed"
                    v-if="!(message.type === 'audio' && message.isDeleted)"
                >
                    <template #default>
                        <button v-if="message.readStatus != 'pending'" class="btn dropdown-toggle" type="button" aria-haspopup="true" aria-expanded="false"
                            @click.stop="handleDropdownOpen">
                            <i class="ri-more-2-fill"></i>
                        </button>
                    </template>

                    <template #popper>
                        <div class="dropdown-menu-v">
                            <template v-if="message.isSent">
                                <button v-if="!message.isDeleted" type="button" @click="onReply" class="dropdown-item-v" v-close-popper>
                                    <i class="ri-reply-line me-2"></i> Responder
                                </button>
                                <button v-if="showEditOption && cLocalShowEdit" type="button" @click="onEdit" class="dropdown-item-v" v-close-popper
                                    :disabled="!canEdit" v-tooltip="motivoBloqueioEdicao">
                                    <i class="ri-pencil-line me-2"></i> Editar
                                </button>
                            </template>

                            <template v-else>
                                <button v-if="!message.isDeleted" type="button" @click="onReply" class="dropdown-item-v" v-close-popper>
                                    <i class="ri-reply-line me-2"></i> Responder
                                </button>
                                <!-- Bloqueado continua focável (`aria-disabled`, não `disabled`) e não
                                     fecha o menu: é o único jeito de o tooltip dizer o motivo. -->
                                <button v-if="podeResponderEmParticular" type="button" class="dropdown-item-v"
                                    :aria-disabled="!!motivoBloqueioParticular || respondendoEmParticular"
                                    :aria-busy="respondendoEmParticular"
                                    v-tooltip="motivoBloqueioParticular"
                                    v-close-popper="!motivoBloqueioParticular && !respondendoEmParticular"
                                    @click="onReplyPrivately">
                                    <i :class="respondendoEmParticular ? 'ri-loader-4-line rotate' : 'ri-chat-private-line'" class="me-2" aria-hidden="true"></i>
                                    Responder em particular
                                </button>
                            </template>

                            <button v-if="!message.isDeleted" type="button" @click="onReact" class="dropdown-item-v" v-close-popper>
                                <i class="ri-emotion-happy-line me-2"></i> Reagir
                            </button>
                            <button v-if="!message.isDeleted && message.type !== 'group-invite'" type="button" @click="onForward" class="dropdown-item-v" v-close-popper>
                                <i class="ri-share-forward-line me-2"></i> Encaminhar
                            </button>
                            <button v-if="!isCopied && message.type !== 'audio' && message.type !== 'sticker'" type="button" @click="onCopy" class="dropdown-item-v"
                                v-close-popper>
                                <i class="ri-file-copy-line text-muted me-2"></i><span>Copiar</span>
                            </button>
                            <button v-else-if="isCopied" type="button" class="dropdown-item-v copied-feedback" disabled>
                                <span>Copiado!</span> <i class="ri-check-line text-success"></i>
                            </button>
                            <li v-if="message.subtype === 'sticker'">
                                <button type="button" class="dropdown-item-v d-flex align-items-center gap-2" @click="addToLibrary(message)">
                                    <i class="ri-star-line text-warning me-0"></i>
                                    <span>Adicionar à biblioteca</span>
                                </button>
                            </li>


                            <!-- <button type="button" @click="onStar" class="dropdown-item-v" v-close-popper
                                v-if="!message.isFavorite">
                                <i class="ri-star-line me-2"></i> <span>Favoritar</span>
                            </button> -->
                            <!-- <button type="button" @click="onStar" class="dropdown-item-v" v-close-popper v-else>
                                <i class="ri-star-fill me-2 text-warning"></i> <span>Desfavoritar</span>
                            </button> -->
                            <!-- Fora do chat interno: não há rota de mensagem fixada
                                 para ele (`/mensagens-fixadas` só conhece contato e
                                 grupo), e o `chatInternoStore` não tem `mensagensFixadas`
                                 — o clique quebrava no `handlePin` da AreaChatUser. -->
                            <template v-if="!isTeamMode">
                                <button
                                    type="button"
                                    @click="onPin"
                                    class="dropdown-item-v"
                                    v-close-popper
                                    v-if="message.isPinned"
                                >
                                    <i class="ri-unpin-line me-2"></i> <span>Desafixar</span>
                                </button>
                                <button
                                    type="button"
                                    @click="onPin"
                                    class="dropdown-item-v"
                                    v-close-popper
                                    v-else
                                >
                                    <i class="ri-pushpin-line me-2"></i> <span>Fixar</span>
                                </button>
                            </template>
                            <template v-if="!isTeamMode && message.isSent && !message.isDeleted && cLocalShowDelete">
                                <div class="dropdown-divider-v" v-if="!isTeamMode && message.isSent && !message.isDeleted">
                                </div>
                                <button type="button" @click="onDelete" class="dropdown-item-v text-danger" v-close-popper
                                    :disabled="!canDelete" v-tooltip="motivoBloqueioEdicao">
                                    <i class="ri-delete-bin-line me-2"></i> Apagar
                                </button>
                            </template>
                        </div>
                    </template>
                </DropdownField>


            </div>
        </div>

        <button
            v-if="message.uploadError && !message.isDeleted && message.isSent"
            class="failed-msg-error-btn"
            @click.stop="isErrorModalOpen = true"
            title="Mensagem não enviada. Clique para saber mais."
        >
            <i class="ri-error-warning-fill"></i>
        </button>

        <Teleport to="body">
            <div v-if="isErrorModalOpen" class="failed-msg-modal-backdrop" @click.self="isErrorModalOpen = false">
                <div class="failed-msg-modal">
                    <p class="failed-msg-modal__msg">Sua mensagem não foi enviada.</p>
                    <div class="failed-msg-modal__actions">
                        <button class="failed-msg-modal__cancel" @click.stop="isErrorModalOpen = false">Cancelar</button>
                        <button class="failed-msg-modal__retry" @click.stop="onRetryFromModal">Tentar novamente</button>
                    </div>
                </div>
            </div>
        </Teleport>
    </li>
</template>

<script lang="ts">
import FalhaEnvioMeta from './FalhaEnvioMeta.vue';
import { computed, defineAsyncComponent, defineComponent, PropType, ref } from 'vue';
import { hideAllPoppers } from 'floating-vue';
import ChatMessageAudio from './ChatMessageAudio.vue'; // Revertido para exportação padrão
import { useUiStore } from '@/stores/app/uiStore';
import { useChatStore } from '@/stores/app/chatStore';
import { toast } from 'vue3-toastify';
import { useInternalChatStore } from '@/stores/app/chatInternoStore';
import { CHAVE_VOTANTE_PROPRIO, extractInitials, FormatTime, GetReplyIconFromType, MakeChat, pastelColorFromString, PREFIXO_VOTANTE_LID, rotuloDeCompartilhamento, rotuloCurtoDeCompartilhamento, extrairCamposPix } from '@/stores/app/chatUtils';
import { ChatMessageType, ListOption, Message, PollData, PollOption } from '@/mocks/app/mockChatData';
import { branding } from '@/config/branding';
import { watch } from 'vue';
/**
 * O seletor de emoji são ~145 KiB de JS mais o CSS dele, e só aparece quando o
 * operador clica em "mais emojis" — o `v-if="isPickerOpen"` no template já o
 * mantinha fora do DOM. Fora do DOM não é fora do bundle: estaticamente
 * importado, ele viajava no chunk de entrada para TODO mundo que abre o chat.
 *
 * `defineAsyncComponent` o move para um chunk próprio, buscado no primeiro
 * clique. O CSS vai junto, no mesmo carregamento, senão ele continuaria na
 * folha de estilo de entrada.
 */
const EmojiPicker = defineAsyncComponent(async () => {
    await import('vue3-emoji-picker/css');
    return (await import('vue3-emoji-picker')).default;
});
import { ehTransporteMeta, MOTIVOS_BLOQUEIO_TRANSPORTE } from '@/utils/transporte'
import { permiteApagarMensagemEnviada } from '@/utils/plataforma';
import { formatPhone, normalizarPhone } from '@/utils/phone';
import { motivoBloqueioRespostaParticular as bloqueioRespostaParticular } from '@/utils/participanteGrupo';
import { downloadAudioFile } from '@/utils/audio/downloadAudioFile';
import VideoDeChat from './VideoDeChat.vue';
import { resolveSelectableMessageIds } from '@/utils/resolveSelectableMessageIds';
import ChatMessageMedia from './ChatMessageMedia.vue';
import ChatTemplateMeta from './ChatTemplateMeta.vue';
import ChatMessageText from './ChatMessageText.vue';
import { escapeHtml } from '@/utils/escapeHtml';
/**
 * `PollVoterLabel` mora no componente que DESENHA a lista, não aqui: o card
 * apenas produz os rótulos e os entrega. `key` é a chave crua de
 * `conteudo.votos` (serve de `:key` e nunca colide); `label` é o que aparece.
 * `isLid` marca quem a plataforma não identificou — não é gente anônima, é
 * endereço opaco, e o card não pretende ter nome dele.
 */
import PollVotersList, { type PollVoterLabel } from './PollVotersList.vue';

/** Avatares na pilha da opção antes de tudo virar "+N". */
const PREVIA_VOTANTES_NA_OPCAO = 3;

export default defineComponent({
    name: 'ChatMessage',
    components: { ChatMessageAudio, EmojiPicker, ChatMessageMedia, ChatTemplateMeta, ChatMessageText, PollVotersList, FalhaEnvioMeta, VideoDeChat },
    emits: ['reply','delete','edit','react','forward','star','pin','toggle-forward'],
    props: {
        message: { type: Object as PropType<Message>, required: true },
        isForwarding: { type: Boolean, default: false },
        forwardingMessageIds: { type: Array as PropType<string[]>, default: () => [] },
        highlightQuery: { type: String, default: '' }
    },
    setup(props, { emit }) {

        const chatStore = useChatStore();
        const uiStore   = useUiStore();
        const internalChatStore = useInternalChatStore();

        /**
         * Mostra o bloco com o MOTIVO da recusa de envio.
         *
         * `template_meta` fica de fora porque `ChatTemplateMeta` já desenha o próprio
         * bloco de falha a partir de `metaTemplateData.sendSuccess` — os dois juntos
         * repetiriam a mesma informação na mesma bolha.
         */
        const cMostrarMotivoFalha = computed(() =>
            props.message.readStatus === 'error'
            && props.message.type !== 'template_meta'
            && (!!props.message.motivoFalha || !!props.message.erroCodigo));

        const showEditOption = computed(() => {
            if (props.message.isDeleted) return false;
            // `canEdit` NÃO entra aqui: bloqueio por transporte aparece desabilitado
            // com o motivo no tooltip, em vez de sumir sem explicação (NFR-5).
            if (props.message.type === 'audio') return false;
            if (props.message.subtype === 'sticker') return false;

            // Documentos não suportam edição de legenda (Evolution retorna "Message not compatible")
            const isDocumento = props.message.type === 'file' && !props.message.fileData?.mimeType?.startsWith('image/') && !props.message.fileData?.mimeType?.startsWith('video/');
            if (isDocumento) return false;

            const mediaTypes = ['imagem', 'file', 'video'];
            if (mediaTypes.includes(props.message.type)) {
                return !!props.message.fileData?.caption;
            }

            return true;
        });

        const handleGroupAvatarClick = () => {
            if (props.message.groupSenderCodigo) {
                (chatStore as any).openParticipantProfile(
                    props.message.groupSenderCodigo,
                    props.message.sender || 'Participante'
                );
            }
        };

        const addToLibrary = async (msg: Message) => {
            const stickerUrl = msg.fileData?.url;

            if (!stickerUrl) {
                toast.error('Não foi possível obter a imagem da figurinha.');
                return;
            }

            // Adicione 'await' aqui para esperar a Promise resolver
            const result = await chatStore.addStickerToLibrary(stickerUrl);

            if (result.success) {
                toast.success(result.message);
            } else {
                toast.info(result.message);
            }
        };

        const openGridMedia = (subMessage: any, index: number) => {
            // No modo seleção o clique na miniatura seleciona o álbum inteiro em vez de
            // abrir o visualizador — senão só o checkbox lateral seria clicável.
            if (props.isForwarding) {
                emit('toggle-forward', resolveSelectableMessageIds(props.message));
                return;
            }

            if (!subMessage.fileData) return;
            const gridMessages = (props.message as any).gridMessages as any[];

            const gallery = gridMessages
                .filter(m => m.fileData)
                .map(m => ({
                    url    : m.fileData.url,
                    type   : m.fileData.mimeType.startsWith('video/') ? 'video' : 'image' as 'image'|'video',
                    caption: m.fileData.caption ?? ''
                }));

            uiStore.openMediaViewer(
                subMessage.fileData.url,
                subMessage.fileData.mimeType.startsWith('video/') ? 'video' : 'image',
                subMessage.fileData.caption ?? '',
                gallery,
                index
            );
        };

        /** Esta mensagem específica saiu/entrou pela Cloud API? */
        const ehMensagemDeTransporteMeta = computed(() => ehTransporteMeta(props.message.idExterno));

        /**
         * Editar e apagar-para-todos exigem o id da mensagem NO transporte que a
         * enviou. A Cloud API não expõe essas operações; a Evolution sim.
         *
         * Em coexistência o transporte vem do `idExterno` (prefixo `wamid.`), não
         * do tipo da mensagem: a heurística por tipo só acertava `template_meta` e
         * errava tudo que sai pela Cloud API por preferência de transporte.
         */
        const transporteSuportaEdicao = computed(() => {
            const plataforma = chatStore.activeChatType;
            // Instagram/Messenger: a API da Meta não expõe apagar nem editar
            // mensagem já enviada. Antes o botão vinha habilitado nessas
            // plataformas e o clique só produzia um 400 do servidor.
            if (!permiteApagarMensagemEnviada(plataforma)) return false;
            if (plataforma == 'WHATSAPP_META') return false;
            if (plataforma == 'WHATSAPP_HYBRID_COEXISTENCE') return !ehMensagemDeTransporteMeta.value;
            return true;
        });

        const canEdit = transporteSuportaEdicao;
        const canDelete = transporteSuportaEdicao;

        /** Texto do bloqueio de editar/apagar; vazio quando liberado. */
        const motivoBloqueioEdicao = computed(() => {
            if (transporteSuportaEdicao.value) return '';
            if (!permiteApagarMensagemEnviada(chatStore.activeChatType))
                return MOTIVOS_BLOQUEIO_TRANSPORTE.edicaoInboxMetaSocial;
            return chatStore.activeChatType == 'WHATSAPP_HYBRID_COEXISTENCE'
                ? MOTIVOS_BLOQUEIO_TRANSPORTE.edicaoTransporteMeta
                : MOTIVOS_BLOQUEIO_TRANSPORTE.edicaoInboxOficial;
        });

        const isTeamMode = computed(() => chatStore.isTeamMode);
        const isGroupContext = computed(() => {
            const active = chatStore.activeChat;
            return !!(active && (active.isGroup === true || active.id.startsWith('g') || active.id.includes('@g.us')));
        });

        /**
         * "Responder em particular" só existe para mensagem de OUTRA pessoa no grupo.
         * Exigir o remetente de grupo também tira a opção dos visualizadores de histórico,
         * que reaproveitam este componente com mensagens 1:1.
         */
        const podeResponderEmParticular = computed(() =>
            isGroupContext.value
            && !isTeamMode.value
            && !internalChatStore.isInternalChatMode
            && !props.message.isSent
            && !props.message.isDeleted
            && !!(props.message.groupSenderId || props.message.groupSenderCodigo));

        /** Motivo do bloqueio; vazio quando liberado (mesmo contrato de `motivoBloqueioEdicao`). */
        const motivoBloqueioParticular = computed(() => {
            const grupo = chatStore.activeChat;
            return bloqueioRespostaParticular({
                // Lista ainda não buscada: a ação carrega e confere no clique.
                participantes: grupo?.participantsFetchedAt ? grupo.participants : undefined,
                remetente: { idContato: props.message.groupSenderId, codigo: props.message.groupSenderCodigo },
                plataforma: chatStore.activeChatType,
            }) ?? '';
        });

        const respondendoEmParticular = computed(() => !!chatStore.inProgressMap.get('responderEmParticular'));

        const senderAvatar = ref<null|string>(null);
        watch([() => props.message, () => chatStore.activeChat?.avatar], async () => {
            // Mensagem enviada por um Atendente? Então caçamos o usuário e a imagem de perfil correspondente
            if (props.message.isSent) {
                const usuariosDaContaLogada = await chatStore.currentAccountUsuarios;
                // ID-based lookup (mensagens confirmadas pelo servidor via WS)
                if (props.message.idUsuarioSender) {
                    return senderAvatar.value = usuariosDaContaLogada.find(u => u.id == props.message.idUsuarioSender)?.foto ?? null;
                }
                // Name-based fallback (mensagens otimistas/pending ainda sem idUsuarioSender)
                const nomeBusca = props.message.agentName ?? props.message.senderNome;
                return senderAvatar.value = usuariosDaContaLogada.find(u => u.nome == nomeBusca)?.foto ?? null;
            }

            // Se não foi enviada por um atendente, verificamos se veio de grupo e já tem o link de mão beijada
            if (props.message.groupSenderImg) {
                return senderAvatar.value = props.message.groupSenderImg;
            }

            // Se não é um grupo OU não tem a imagem de mão beijada, busquemos pelo contato que enviou a mensagem
            if (props.message.idContatoSender) {
                const imagemContato = chatStore.contatosById.get(props.message.idContatoSender)?.imagem;
                if (imagemContato) return senderAvatar.value = imagemContato;
            }

            // Conversa 1:1: quem enviou é o dono do chat, e o avatar dele já está no
            // activeChat (o mesmo que o cabeçalho exibe). Cobre o contato que ainda não
            // está na página de contatos carregada em `contatosById`.
            if (!isGroupContext.value) {
                return senderAvatar.value = chatStore.activeChat?.avatar ?? null;
            }

            // Se nada disso funcionar, retornamos nada.
            return senderAvatar.value = null;

            // if ( !isGroupContext.value || !props.message.sender ) return null;

            // const participants = chatStore.activeChat?.participants;
            // if (!participants) return null;

            // const found = participants.find(p => p.phone === props.message.groupSenderCodigo);
            // return found?.avatar || null;
        }, {immediate: true});

        const resolvedSenderName = computed(() => {
            const participants = chatStore.activeChat?.participants;
            if (!participants?.length) return props.message.sender;

            const byId = props.message.idContatoSender
                ? participants.find(p => p.idContato === props.message.idContatoSender)
                : undefined;
            if (byId) return byId.name;

            const byPhone = props.message.groupSenderCodigo
                ? participants.find(p => p.phone === props.message.groupSenderCodigo)
                : undefined;
            return byPhone?.name || props.message.sender;
        });

        const senderBorderColor = computed(() => {
            if (!resolvedSenderName.value) return 'transparent';
            return pastelColorFromString(resolvedSenderName.value);
        });

        const messages = computed(() => internalChatStore.messages);

        /**
         * Largura da barra de uma opção, relativa à opção MAIS votada.
         *
         * Não é `votos / totalVotantes`: numa enquete de múltipla escolha a soma
         * das opções passa do número de votantes, e uma opção votada por todos
         * daria mais de 100 %. Relativo ao máximo, a mais votada sempre enche a
         * barra e as outras ficam proporcionais a ela — que é o que o WhatsApp
         * desenha.
         */
        const pollBarWidth = (poll: PollData | undefined, votes: number | undefined): string => {
            const maximo = Math.max(0, ...(poll?.options ?? []).map(o => o.votes || 0));
            if (!maximo) return '0%';
            return `${Math.round(((votes || 0) / maximo) * 100)}%`;
        };

        /**
         * O rótulo serve como nome de gente?
         *
         * Mesma regra de `nomeExibivel` no chatStore: participante sem nome chega com
         * o próprio código no campo `name`, e telefone não é nome — exibi-lo aqui
         * duplicaria o número que o último degrau já formata direito.
         */
        const nomeDeVotanteExibivel = (nome: string | null | undefined): string | null => {
            const limpo = (nome ?? '').trim();
            if (!limpo) return null;
            const semSeparadores = limpo.replace(/[\s+()\-.]/g, '');
            if (!semSeparadores || /^\d+$/.test(semSeparadores)) return null;
            return limpo;
        };

        /**
         * Nomeia uma chave de votante de `conteudo.votos`.
         *
         * A chave é TELEFONE (ou `lid:<dígitos>`, ou `me`), nunca um `idContato`: o
         * servidor guarda quem votou, não quem é. Nomear é decisão do card, e a ordem
         * das fontes é a de `resolvedSenderName`/`rotuloPresenca` — `participants`
         * primeiro, porque é a mesma fonte que nomeia e colore as bolhas logo acima na
         * conversa; inverter faria o popover discordar da tela.
         */
        /**
         * Forma canônica de uma chave de votante que é TELEFONE.
         *
         * A guarda de dígitos puros espelha a do servidor e não é decoração:
         * `normalizarPhone` começa com `replace(/\D/g, '')` e, quando o número não é
         * BR, devolve esse resultado JÁ SEM os não-dígitos — não a entrada. Sem a
         * guarda ela apagaria o sufixo `-group` que o servidor põe no lugar de
         * `@g.us`, e `formatPhone` depois apresentaria um id de grupo como se fosse
         * telefone (`+1203631234`).
         */
        const canonizarTelefone = (chave: string): string =>
            /^\d+$/.test(chave) ? normalizarPhone(chave) : chave;

        /**
         * Iniciais de um votante, ou vazio quando o rótulo não começa por letra.
         *
         * `extractInitials` é `slice(0, 3).toUpperCase()`. Participante anônimo de
         * grupo de aviso chega com o telefone REDIGIDO pelo próprio WhatsApp
         * (`+55 35 ****-2222`), que passa por `nomeDeVotanteExibivel` porque os `*`
         * derrubam o teste de só-dígitos — e viraria a inicial `+55`. Sem letra, o
         * card mostra o ícone genérico, que não finge ser nome.
         */
        const iniciaisDeVotante = (rotulo: string): string =>
            /^\p{L}/u.test(rotulo) ? extractInitials(rotulo) : '';

        /**
         * Nomeia uma chave de votante de `conteudo.votos`.
         *
         * A chave é TELEFONE (ou `lid:<dígitos>`, ou `me`), nunca um `idContato`: o
         * servidor guarda quem votou, não quem é. Nomear é decisão do card, e a ordem
         * das fontes é a de `resolvedSenderName`/`rotuloPresenca` — `participants`
         * primeiro, porque é a mesma fonte que nomeia e colore as bolhas logo acima na
         * conversa; inverter faria o popover discordar da tela.
         */
        const resolverVotante = (chave: string): PollVoterLabel => {
            // Voto nosso não tem número no evento (em 1:1 o `remoteJid` é sempre o do
            // outro lado), então vem com chave literal.
            if (chave === CHAVE_VOTANTE_PROPRIO) {
                return { key: chave, label: 'Você', initials: 'EU', isLid: false };
            }

            const ehLid = chave.startsWith(PREFIXO_VOTANTE_LID);
            // LID: identificador opaco, não telefone. Não passa pelo normalizador (os
            // dígitos não são número de ninguém), mas PASSA pelas mesmas fontes de
            // nome: `grupos.service` devolve o `codigo` do participante LID cru, e um
            // contato LID-only guarda os dígitos do LID no próprio `codigo`.
            const chaveNormalizada = ehLid
                ? chave.slice(PREFIXO_VOTANTE_LID.length)
                : canonizarTelefone(chave);

            // Comparação por número NORMALIZADO, nunca `===` na chave crua.
            //
            // O outro lado já vem normalizado: `participants[].phone` sai de
            // `grupos.service` por `normalizarBRNumero`, e `contato.codigo` sai de
            // `mensagens-processamento` pelo mesmo caminho. O WhatsApp ainda entrega
            // número BR legado de 12 dígitos (sem o 9), e o `===` cru errava o
            // votante: contagem certa, nome nenhum. O servidor agora normaliza na
            // ESCRITA, mas normalizar aqui também é o que resgata o voto JÁ gravado no
            // Cassandra, que nenhuma escrita futura reescreve.
            const mesmoNumero = (outro?: string) =>
                !!outro && (outro === chaveNormalizada || canonizarTelefone(outro) === chaveNormalizada);

            // Participante LID casa por dígitos crus; participante comum, por número.
            const participante = chatStore.activeChat?.participants?.find(p =>
                ehLid ? p.isLid && p.phone === chaveNormalizada : !p.isLid && mesmoNumero(p.phone),
            );
            const doParticipante = nomeDeVotanteExibivel(participante?.name);
            if (doParticipante) {
                return {
                    key: chave,
                    label: doParticipante,
                    initials: iniciaisDeVotante(doParticipante),
                    avatar: participante?.avatar,
                    isLid: ehLid,
                };
            }

            // O mapa é indexado pelo `codigo` do contato COMO O SERVIDOR GRAVOU. Tenta
            // as duas formas de propósito: `normalizarBRNumero` entrou no whiz depois
            // que a tabela já existia e nunca houve backfill, então há linha antiga
            // com o número legado e linha nova com o normalizado. Buscar só uma das
            // duas troca um acerto por outro — é o padrão que `ChatMessageText.vue` já
            // usa. `imagem` é do CONTATO: aqui `participante` é, por construção, quem
            // não tinha nome.
            const contato =
                chatStore.contatosByCodigo.get(chave) ?? chatStore.contatosByCodigo.get(chaveNormalizada);
            const doStore = nomeDeVotanteExibivel(contato?.nome);
            if (doStore) {
                return {
                    key: chave,
                    label: doStore,
                    initials: iniciaisDeVotante(doStore),
                    avatar: contato?.imagem ?? undefined,
                    isLid: ehLid,
                };
            }

            // Conversa 1:1: além de nós, o único votante possível é o outro lado, e o
            // nome da conversa é o dele. Vale para o contato que ainda não está na
            // página de contatos carregada — e vale especialmente para o votante `lid:`,
            // que só existe em 1:1 que o wa-go não conseguiu resolver para PN: ali o
            // votante É o dono da conversa, e recusar o nome do cabeçalho deixava
            // anônimo justamente o caso que o prefixo existe para marcar.
            if (!chatStore.activeChat?.isGroup && mesmoNumero(chatStore.activeChat?.codigoContato)) {
                const doChat = nomeDeVotanteExibivel(chatStore.activeChat?.name);
                if (doChat) {
                    return {
                        key: chave,
                        label: doChat,
                        initials: iniciaisDeVotante(doChat),
                        avatar: chatStore.activeChat?.avatar ?? undefined,
                        isLid: ehLid,
                    };
                }
            }

            // Sem nome em fonte nenhuma. Dígitos de LID não são telefone e mostrá-los
            // inteiros disfarçaria endereço de número — vira o mesmo rótulo dos
            // participantes não identificados do grupo, com os 4 finais para não
            // colapsar pessoas diferentes no mesmo nome. Telefone é informação de
            // verdade, então vale mais que "Participante" — só não vira inicial, que
            // ficaria sendo o DDI de todo mundo.
            if (ehLid) {
                return {
                    key: chave,
                    label: MakeChat.rotuloParticipanteSemNome(chaveNormalizada),
                    initials: '',
                    isLid: true,
                };
            }
            return { key: chave, label: formatPhone(chaveNormalizada), initials: '', isLid: false };
        };

        /**
         * Tudo o que o card precisa saber sobre os votantes, UMA opção por posição.
         *
         * `computed`, e não funções chamadas do template, porque a pilha de rostos
         * mora no GATILHO — que é desenhado sempre, ao contrário do popover, que o
         * floating-vue só monta no primeiro clique. Como função, `pollVoters` rodaria
         * duas vezes por opção a cada render (uma pela prévia, outra pelo excedente),
         * e cada passada resolve todo votante contra todo participante: num grupo de
         * 500 com 200 votos são dezenas de milissegundos por render, e `ChatMessage`
         * re-renderiza a cada hover, reação e mudança de situação.
         *
         * `String()` na chave porque a lista sai de `conteudo.votos`, que é dado do
         * servidor (e de mensagem montada por versão anterior do front, quando o campo
         * era numérico): uma chave não-string derrubaria o `startsWith` do resolvedor
         * e com ele a bolha inteira.
         */
        const pollVotersPorOpcao = computed(() =>
            (props.message.pollData?.options ?? []).map((option, idx) => {
                const voters = (option.voters ?? []).map(chave => resolverVotante(String(chave)));
                const votes = option.votes || 0;
                // Corta em `PREVIA_VOTANTES_NA_OPCAO` porque a pilha divide a linha com
                // o texto da opção: mais rostos empurrariam a contagem para fora da
                // bolha.
                const preview = voters.slice(0, PREVIA_VOTANTES_NA_OPCAO);
                return {
                    // `key` sai do índice porque nome de opção pode repetir na mesma
                    // enquete.
                    key: `${idx}`,
                    text: option.text,
                    votes,
                    voters,
                    preview,
                    // O excedente conta contra `votes` menos os rostos DESENHADOS, não
                    // menos o corte fixo: o voto que chegou ao vivo move a contagem sem
                    // dizer quem votou, então uma opção pode ter 2 votos e nenhum
                    // votante nomeado. Descontando o corte, o "+N" daria zero ali e o
                    // gatilho voltaria a ser um número pelado — o mesmo que ninguém
                    // descobria.
                    overflow: Math.max(0, votes - preview.length),
                    // Votos sem votante conhecido na tela. O evento ao vivo
                    // (`MENSAGEM.ENQUETE_VOTO`) é estreito de propósito: move a
                    // contagem sem dizer QUEM. Exibir a diferença mantém a lista e a
                    // barra coerentes — esconder faria o popover listar 2 nomes sob uma
                    // barra que diz 3, o que parece bug e não é.
                    unnamedVotes: Math.max(0, votes - voters.length),
                };
            }),
        );

        /**
         * Só as opções COM voto, para o popover do "Ver votos": seção vazia não
         * informa nada e afastaria as que importam. É também o que decide se o botão
         * existe — sem isto, uma enquete com `votosContagem` ilegível abriria um
         * popover vazio, o clique que não responde nada.
         */
        const pollVotersComVoto = computed(() => pollVotersPorOpcao.value.filter(grupo => grupo.votes > 0));

        return {
            pollBarWidth,
            pollVotersPorOpcao,
            pollVotersComVoto,
            pastelColorFromString,
            chatStore,
            uiStore,
            isTeamMode,
            isGroupContext,
            podeResponderEmParticular,
            motivoBloqueioParticular,
            respondendoEmParticular,
            canEdit,
            canDelete,
            motivoBloqueioEdicao,
            messages,
            branding,
            senderAvatar,
            senderBorderColor,
            resolvedSenderName,
            openGridMedia,
            addToLibrary,
            handleGroupAvatarClick,
            showEditOption,
            cMostrarMotivoFalha,
        };
    },
    data() {
        return {
            isHovered: false,
            isReactionPickerOpen: false,
            isPickerOpen: false,
            isCopied: false,
            isErrorModalOpen: false,
            /**
             * Thumb da Meta expira; quando o <img> falha caímos no ícone da rede.
             * Guarda a URL que falhou, e não um booleano: se o servidor trocar a
             * thumb depois (upload para o S3 concluído), a nova é tentada.
             */
            anuncioThumbQuebrada: undefined as string | undefined,
            popularEmojis: ['👍', '❤️', '😂', '😮', '😢', '🙏']
        };
    },
    methods: {
        /** Só http(s) vira `href`/`src`; qualquer outro esquema é descartado. */
        anuncioUrlSegura(url?: string): string | undefined {
            return url && /^https?:\/\//i.test(url) ? url : undefined;
        },

        async downloadAudio(url?: string): Promise<void> {
            if (!url) return;

            try {
                await downloadAudioFile(url, `audio-${this.message.id || Date.now()}`);
            } catch (error) {
                console.error('Erro ao tentar baixar o áudio:', error);
            }
        },

        isReplyMedia(): boolean {
            const replyMessage = this.getReplyMessage();
            if (!replyMessage) return false;

            const mediaTypes = ['file', 'imagem', 'video', 'audio', 'contact', 'location', 'poll', 'event'];
            return mediaTypes.includes(replyMessage.type);
        },

        /**
         * Obtém a mensagem respondida do array de mensagens
         */
        getReplyMessage(): Message | undefined {
            if (!this.message.replyToId || !this.messages) {
                return undefined;
            }
            return this.messages.find((m: Message) => m.id === this.message.replyToId);
        },

        /**
         * Retorna o ícone correspondente ao tipo de mídia
         */
        getReplyMediaIcon(type?: ChatMessageType): string|undefined {
            return GetReplyIconFromType(type);
        },

        /**
         * Retorna o rótulo do tipo de mídia
         */
        getReplyMediaLabel(): string {
            const replyMessage = this.getReplyMessage();
            if (!replyMessage) return 'Mídia';

            const labelMap: Record<string, string> = {
                'imagem': 'Imagem',
                'file': 'Arquivo',
                'video': 'Vídeo',
                'audio': 'Áudio',
                'contact': 'Contato',
                'location': 'Localização',
                'poll': 'Enquete',
                'event': 'Evento'
            };

            // Se for arquivo, pode incluir a extensão
            if (replyMessage.type === 'file' && replyMessage.fileData?.name) {
                const ext = replyMessage.fileData.name.split('.').pop()?.toUpperCase() || '';
                return ext ? `Arquivo ${ext}` : 'Arquivo';
            }

            return labelMap[replyMessage.type] || 'Mídia';
        },


        openMapExternal(lat?: number|string, lng?: number|string): void {
            if (!lat || !lng) return;
            window.open(`https://maps.google.com/maps?q=${lat},${lng}`, '_blank');
        },

        formatTime(time: string): string {
            return FormatTime(time);
        },
        
        handleDropdownOpen(): void {
            hideAllPoppers();
        },

        onDoubleClickReply(): void {
            if (this.message.isDeleted || this.isForwarding || this.message.readStatus === 'pending') return;
            window.getSelection()?.removeAllRanges();
            this.$emit('reply', this.message);
        },
        onReply(): void {
            this.$emit('reply', this.message);
        },
        onReplyPrivately(): void {
            // `aria-disabled` não barra o clique: a guarda é aqui.
            if (this.motivoBloqueioParticular || this.respondendoEmParticular) return;
            void this.chatStore.responderEmParticular(this.message);
        },
        onDelete(): void {
            this.$emit('delete', this.message);
        },
        onEdit(): void {
            this.$emit('edit', this.message);
        },

        onReact(): void {
            this.isHovered = true;
        },
        onEmojiSelect(emoji: unknown): void {
            const internalChatStore = useInternalChatStore();
            if (internalChatStore.isInternalChatMode) {
                internalChatStore.reactToMessage(this.message, emoji as string);
            } else {
                this.chatStore.reactToMessage(this.message, emoji as string);
            }
            this.isHovered = false;
        },
        onForward(): void {
            this.$emit('forward', this.message);
        },
        onRetryFromModal(): void {
            this.isErrorModalOpen = false;
            this.chatStore.retryFailedMessage(this.message);
        },
        onCopy(): void {
            // Não emite mais, o componente lida com tudo
            // this.$emit('copy', this.message);

            let contentToCopy = '';

            if ((this.message as Message).text) {
                contentToCopy = (this.message as Message).text!;
            } else if ((this.message as Message).fileData?.caption) {
                contentToCopy = (this.message as Message).fileData!.caption!;
            } else if ((this.message as Message).type === 'audio' && (this.message as Message).audioUrl) {
                contentToCopy = (this.message as Message).audioUrl!;
            } else if ((this.message as Message).type === 'list') {
                contentToCopy = (this.message as Message).listHeader || 'Lista';
            } else {
                return; // Não há o que copiar
            }

            navigator.clipboard.writeText(contentToCopy)
                .then(() => {
                    this.isCopied = true;

                    setTimeout(() => {
                        this.isCopied = false;
                    }, 1500);
                })
                .catch(err => {
                    console.error("Falha ao copiar: ", err);
                });
        },
        onStar(): void {
            this.$emit('star', this.message);
        },
        onPin(): void {
            this.$emit('pin', this.message);
        },



        openListModal(message: Message): void {
            if (message.listOptions && message.listOptions.length > 0) {

                this.uiStore.openListMessageModal({
                    title    : message.listHeader || 'Selecione uma opção',
                    options  : message.listOptions,
                    messageId: message.id
                });

            } else {
                console.warn('Nenhuma opção encontrada para esta mensagem de lista.');
                this.uiStore.openListMessageModal({
                    title: 'Opções (Teste)',
                    options: [
                        { id: '1', text: 'Opção 1 (Fallback)' },
                        { id: '2', text: 'Opção 2 (Fallback)' }
                    ],
                    messageId: message.id
                });
            }
        },

        getFileExtension(mimeType?: string, fileName?: string): string {
            if (mimeType && mimeType.includes('/')) {
                const parts = mimeType.split('/');
                if (parts[1]) return parts[1].toUpperCase();
            }
            if (fileName && fileName.includes('.')) {
                return fileName.split('.').pop()!.toUpperCase();
            }
            return 'FILE';
        },

        isPixMessage(): boolean {
            return this.message.type === 'list' &&
                !!this.message.listHeader &&
                this.message.listHeader.includes('Chave PIX');
        },

        isPasswordMessage(): boolean {
            return this.message.type === 'list' &&
                !!this.message.listHeader &&
                (this.message.listHeader.includes('Senha Única') || this.message.listHeader.includes('Código:'));
        },

        extractData(label: string): string {
            if (!this.message.listHeader) return '';
            const regex = new RegExp(`${label}\\s*(.*)`, 'i');
            const match = this.message.listHeader.match(regex);
            if (match && match[1]) {
                return match[1].replace(/\*/g, '').trim();
            }
            return '';
        },

        copyData(text: string): void {
            if (!text) return;
            // navigator.clipboard só existe em secure context (https/localhost).
            // Fora disso (ex.: front acessado por IP em http), cai no fallback.
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).catch(() => this.fallbackCopy(text));
            } else {
                this.fallbackCopy(text);
            }
            // Se tiver toast disponível: this.$toast.success('Copiado!');
        },

        fallbackCopy(text: string): void {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Falha ao copiar: ', err);
            }
            document.body.removeChild(textarea);
        },

        isActionableButton(option: ListOption): boolean {
            return ['COPIA', 'URL', 'LIGACAO'].includes(option.actionType ?? '');
        },

        onInteractiveButtonClick(option: ListOption): void {
            if (option.actionType === 'COPIA' && option.copyCode) {
                this.copyData(option.copyCode);
                this.isCopied = true;
                setTimeout(() => { this.isCopied = false; }, 1500);
            } else if (option.actionType === 'URL' && option.url) {
                window.open(option.url, '_blank', 'noopener');
            } else if (option.actionType === 'LIGACAO' && option.phone) {
                window.open(`tel:${option.phone}`, '_self');
            }
            // RESPOSTA / demais: apenas exibição, sem ação.
        },

        onPickerEmojiSelect(emojiObj: { i: string }): void {
            if (!emojiObj?.i) return;
            this.onEmojiSelect(emojiObj.i);
            this.isPickerOpen = false;
        },
    },
    computed: {
        pixCampos(): { titular: string, chave: string, corpo: string } {
            return extrairCamposPix(this.message.listHeader);
        },
        /**
         * Miniatura do criativo. O servidor já entrega a NOSSA cópia no S3 quando
         * conseguiu subir, e só cai para a URL da Meta (que expira) se não conseguiu.
         */
        anuncioThumb(): string | undefined {
            const url = this.anuncioUrlSegura(this.message.anuncio?.thumbnailUrl);
            return url && url === this.anuncioThumbQuebrada ? undefined : url;
        },
        /**
         * Título e corpo são cortados em 2/3 linhas no card; o texto inteiro sobra
         * no tooltip para o atendente que precisa do nome completo do produto.
         */
        anuncioTooltip(): string | undefined {
            const partes = [this.message.anuncio?.titulo, this.message.anuncio?.corpo]
                .filter((p): p is string => !!p && !!p.trim());
            return partes.length ? partes.join(' — ') : undefined;
        },
        /**
         * `href` do card. O servidor já filtra o esquema, mas o filtro é repetido aqui:
         * é campo livre escrito por quem comprou o anúncio, e mensagem antiga (gravada
         * antes do filtro) continua no histórico. `javascript:` num `href` é XSS de um
         * clique.
         */
        anuncioUrl(): string | undefined {
            return this.anuncioUrlSegura(this.message.anuncio?.url);
        },
        anuncioSelo(): string {
            const app = (this.message.anuncio?.app ?? '').toLowerCase();
            if (app.includes('instagram')) return 'Anúncio do Instagram';
            if (app.includes('facebook')) return 'Anúncio do Facebook';
            return 'Anúncio';
        },
        /**
         * `href` do cartão de publicação compartilhada. Passa pelo MESMO filtro de
         * esquema do anúncio: a URL vem do payload da Meta, e `javascript:` num
         * `href` é XSS de um clique.
         */
        compartilhamentoUrl(): string | undefined {
            return this.anuncioUrlSegura(this.message.compartilhamento?.url);
        },
        /** Rótulo do SELO (acima da mídia), onde há largura de sobra. */
        rotuloCompartilhamento(): string {
            return rotuloDeCompartilhamento(this.message.compartilhamento?.origem);
        },
        /** Rótulo do CARTÃO, curto para caber ao lado da miniatura sem quebrar. */
        rotuloCompartilhamentoCurto(): string {
            return rotuloCurtoDeCompartilhamento(this.message.compartilhamento?.origem);
        },
        /**
         * A publicação compartilhada veio COM mídia re-hospedada (`ig_post`). Aí a
         * bolha desenha a mídia normal e o compartilhamento vira só um selo; sem
         * mídia (`ig_reel`/`share`, que só trazem permalink) é o cartão com link.
         */
        compartilhamentoComMidia(): boolean {
            return !!this.message.compartilhamento && !!this.message.fileData?.url;
        },
        /**
         * Quantas mídias a publicação tem. Chega como STRING (MAP<TEXT,TEXT> do
         * Cassandra) e só existe quando a Graph respondeu — o webhook de `ig_post`
         * é idêntico para foto única e para carrossel.
         */
        compartilhamentoTotalMidias(): number | undefined {
            const bruto = Number(this.message.compartilhamento?.totalMidias);
            return Number.isFinite(bruto) && bruto > 1 ? bruto : undefined;
        },
        anuncioIcone(): string {
            const app = (this.message.anuncio?.app ?? '').toLowerCase();
            if (app.includes('instagram')) return 'ri-instagram-line';
            if (app.includes('facebook')) return 'ri-facebook-circle-line';
            return 'ri-megaphone-line';
        },
        cLocalShowEdit() {
            /** Determina se é possível editar uma mensage, caso a mensagem seja de mídia, o que é indicado pela presença de uma legenda. Mensagens de mídia sem legenda são editáveis e recebem legenda via API, mas não é algo observado no comportamento usual do zip zop. */
            const ifIsMediaMessageIsEditingLegal = ['video','imagem','file','audio'].includes(this.message.type) ? (this.message.fileData?.caption?.length && this.message.fileData?.caption?.length > 0) : true;
            const anHoursWorthOfMs = 60 * 60 * 1000;
            const now = Date.now();
            const messageTs = new Date(this.message.time).setMilliseconds(0);
            return (now - anHoursWorthOfMs < messageTs) && ifIsMediaMessageIsEditingLegal;
        },
        cLocalShowDelete() {
            const aDaysWorthOfMs = 24 * 60 * 60 * 1000;
            const now = Date.now();
            const messageTs = new Date(this.message.time).setMilliseconds(0);
            return now - aDaysWorthOfMs < messageTs;
        },
        computedReactions() {
            const lastReactions = Array.from(this.message.reactions?.values() ?? []).filter(r => !/\s/.test(r));
            const emojiCountMap = new Map<string,number>();
            for (const reaction of lastReactions) {
                if (!reaction) continue;
                const found = emojiCountMap.get(reaction);
                if (found) emojiCountMap.set(reaction, found + 1);
                else emojiCountMap.set(reaction, 1)
            }
            return Array.from(emojiCountMap.entries()).map(([emoji, count]) => ({emoji, count}))
        },
        computedReactionsTotal() {
            return this.computedReactions.reduce((acc, obj) => acc += (!obj.emoji ? 0 : obj.count), 0);
        },
        messageWrapperClasses(): Record<string, boolean> {
            if (this.message.isSent) {
                return { 'right': true, 'sent-message': true };
            }
            if (this.message.isBot) {
                return { 'system-message': true };
            }
            // Mensagens de lista/botões recebidas do contato: fundo neutro (sem gradiente da marca).
            if (this.message.type === 'list') {
                return { 'system-message': true, 'interactive-received': true };
            }
            return { 'received-message': true };
        },
        formattedListHeader(): string {
            // Vai para `v-html` (por causa do `<br />`): escapa o texto antes.
            return this.message.listHeader ? escapeHtml(this.message.listHeader).replace(/\n/g, '<br />') : '';
        },
        /**
         * Tooltip do aviso de tipo não suportado. O texto da Meta vem em inglês
         * ("Message type is currently not supported."), então fica no `title` e
         * não no corpo: quem precisa dele é o suporte, para saber QUAL tipo novo
         * chegou. Sem motivo, o tooltip some em vez de mostrar rótulo vazio.
         */
        motivoNaoSuportada(): string | undefined {
            return this.message.motivoNaoSuportada || undefined;
        },
        /**
         * IDs REAIS que este balão representa na store. Um balão de álbum (`media_grid`)
         * tem ID sintético e cobre N mídias — emitir `message.id` faria a seleção guardar
         * um ID que não existe em `store.messages`, e nada seria encaminhado.
         */
        selectionIds(): string[] {
            return resolveSelectableMessageIds(this.message);
        },
        isForwardSelected(): boolean {
            const selected = this.forwardingMessageIds as string[];
            return (this.selectionIds as string[]).every(id => selected.includes(id));
        },
        isReplySelected(): boolean {
            const chatStore = useChatStore();
            const internalChatStore = useInternalChatStore();
            const replyMsg = internalChatStore.messageToReply || chatStore.messageToReply;
            return replyMsg?.id === this.message.id;
        }
    }
})



</script>

<style scoped>
.quoted-reply-wrapper {
    display: flex;
    flex-grow: 1;
    /* min-height: 65px;
    cursor: pointer;
    padding: 8px 12px;
    border-left: 3px solid #4a90e2;
    background-color: rgba(74, 144, 226, 0.1);
    border-radius: 4px;
    margin-bottom: 8px;
    transition: background-color 0.2s ease; */
}

.quoted-reply-wrapper:hover {
    background-color: rgba(74, 144, 226, 0.15);
}

.quoted-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

/* .quoted-owner {
    font-weight: 600;
    font-size: 0.85rem;
    color: #4a90e2;
} */

/* .quoted-snippet {
    font-size: 0.9rem;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
} */

.reply-media-preview {
    display: flex;
    align-items: center;
    gap: 8px;
    /* color: #666; */
    font-size: 0.9rem;
}

.please-match-with-your-sibling {
    height: 65px;
    border-radius: 8px 0 0 8px !important;
}

.reply-media-content-preview {
    /* max-width: 80px; */
    height: 65px;
    border-radius: 0 8px 8px 0;
}

.reply-media-preview i {
    font-size: 1.1rem;
}

li.msg_wpp_render {
    margin-bottom: 16px;
    display: flex;
    position: relative;
    width: 100%;
    padding-right: 20px !important;
}

li.msg_wpp_render.received-message,
li.msg_wpp_render.system-message {
    justify-content: flex-start;
}

li.msg_wpp_render.right {
    justify-content: flex-end;
}

.conversation-list {
    transition: transform 0.3s ease;
    transform: translateX(0);
}

.ctext-wrap {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    position: relative;
}

li.msg_wpp_render .conversation-list .ctext-wrap .ctext-wrap-content {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    max-width: 550px;
    padding: 10px;
    border-radius: 12px;
    position: relative;
    border: none;

    display: inline-block;

    text-align: left;
}

.message-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 14.5px;
    line-height: 1.5;
    white-space: pre-wrap;
}

.chat-time {
    font-size: 11px !important;
    opacity: 0.7;
    margin-top: 8px;
    text-align: right;
    color: var(--bs-text-muted);
}

.ack i {
    font-size: 16px;
    /* color: var(--bs-text-muted); */
}

/*
 * Mesmo azul do check no card da lista (`ChatItem.vue`, inline `#50a5f1`) e da
 * linha de áudio abaixo. Era `#00ffbd` (verde-água) — único lugar do app com
 * essa cor para "lida".
 */
.status-read {
    color: #50a5f1 !important;
}


li.msg_wpp_render .conversation-list .ctext-wrap .ctext-wrap-content::before {
    content: "";
    position: absolute;
    bottom: -9px;
}


[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content {
    background: var(--bs-white, #fff) !important;
    color: var(--bs-body-color) !important;
    border-radius: 12px 12px 12px 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content::before {
    border-top-color: var(--bs-white, #fff) !important;
    border-left-color: var(--bs-white, #fff) !important;
    left: 0;
}

[data-bs-theme=light] li.msg_wpp_render.sent-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    color: #fff !important;
    border-radius: 12px 12px 0 12px;
}

[data-bs-theme=light] li.msg_wpp_render.sent-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-end) !important; /* Ponta pega a cor final do gradiente */
    border-right-color: var(--brand-bubble-gradient-end) !important;
    right: 0;
    left: auto;
}
[data-bs-theme=light] li.msg_wpp_render.system-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    border-radius: 12px 12px 12px 0;
}

[data-bs-theme=light] li.msg_wpp_render.system-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-start) !important;
    border-left-color: var(--brand-bubble-gradient-start) !important;
    left: 0;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .chat-time,
[data-bs-theme=light] li.msg_wpp_render.received-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=light] li.msg_wpp_render.received-message .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.received-message .pinned-icon,
[data-bs-theme=light] li.msg_wpp_render.system-message .chat-time {
    color: rgba(255, 255, 255, 0.9) !important;
}


[data-bs-theme=dark] li.msg_wpp_render.received-message .ctext-wrap-content {
    background: var(--bs-light) !important;
    color: var(--bs-dark) !important;
    border-radius: 12px 12px 12px 0;
}

[data-bs-theme=light] li.msg_wpp_render.received-message :deep(.chat-link) {
    color: #fff !important;
    text-decoration: underline;
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .ctext-wrap-content::before {
    border-top-color: var(--bs-light) !important;
    border-left-color: var(--bs-light) !important;
    left: 0;
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    color: #fff !important;
    border-radius: 12px 12px 0 12px;
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-end) !important;
    border-right-color: var(--brand-bubble-gradient-end) !important;
    right: 0;
    left: auto;
}

[data-bs-theme=dark] li.msg_wpp_render.system-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    color: #fff !important;
    border-radius: 12px 12px 12px 0;
}

[data-bs-theme=dark] li.msg_wpp_render.system-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-start) !important;
    border-left-color: var(--brand-bubble-gradient-start) !important;
    left: 0;
}

/* Mensagem de botões recebida do contato: fundo neutro (sem gradiente da marca).
   O cinza-escuro valia para os DOIS temas, e no claro a lista recebida saía
   como um bloco preto: no claro ela usa a mesma bolha branca da recebida. */
[data-bs-theme=light] li.msg_wpp_render.interactive-received .ctext-wrap-content {
    background: var(--bs-white, #fff) !important;
    color: var(--bs-body-color) !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

[data-bs-theme=light] li.msg_wpp_render.interactive-received .ctext-wrap-content::before {
    border-top-color: var(--bs-white, #fff) !important;
    border-left-color: var(--bs-white, #fff) !important;
}

[data-bs-theme=light] li.msg_wpp_render.system-message.interactive-received .chat-time {
    color: var(--bs-secondary-color) !important;
}

[data-bs-theme=dark] li.msg_wpp_render.interactive-received .ctext-wrap-content {
    background: #2b2b2b !important;
    color: #fff !important;
}

[data-bs-theme=dark] li.msg_wpp_render.interactive-received .ctext-wrap-content::before {
    border-top-color: #2b2b2b !important;
    border-left-color: #2b2b2b !important;
}


/* ── Emoji hover bar (estilo WhatsApp) ── */
.emoji-hover-bar {
    position: absolute;
    bottom: calc(100% + 4px);
    z-index: 200;
    display: flex;
    gap: 2px;
    align-items: center;
    background: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 24px;
    padding: 4px 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    white-space: nowrap;
}

li.msg_wpp_render.right .emoji-hover-bar {
    right: 36px;
}

li.msg_wpp_render:not(.right) .emoji-hover-bar {
    left: 0;
}

.emoji-quick-btn {
    background: none;
    border: none;
    padding: 3px 5px;
    font-size: 20px;
    line-height: 1;
    border-radius: 50%;
    cursor: pointer;
    transition: transform 0.15s ease, background 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.emoji-quick-btn:hover {
    transform: scale(1.35) translateY(-2px);
    background: var(--bs-secondary-bg);
}

/* Transition */
.emoji-bar-enter-active,
.emoji-bar-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}
.emoji-bar-enter-from,
.emoji-bar-leave-to {
    opacity: 0;
    transform: translateY(4px);
}

.emoji-more-btn {
    border-left: 1px solid var(--bs-border-color);
    margin-left: 2px;
    padding-left: 8px;
    color: var(--bs-text-muted);
}

.emoji-more-btn:hover {
    color: var(--bs-body-color);
}

.emoji-picker-wrapper {
    position: absolute;
    bottom: calc(100% + 8px);
    z-index: 300;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
    border-radius: 12px;
    overflow: hidden;
}

li.msg_wpp_render.right .emoji-picker-wrapper {
    right: 0;
}

li.msg_wpp_render:not(.right) .emoji-picker-wrapper {
    left: 0;
}

.bot-list-button {
    font-weight: 500;
    border-radius: 6px;
    padding: 10px 12px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    background: var(--bs-green);
    color: white;
    box-shadow: var(--bs-box-shadow);
}
.bot-list-button:hover {
    background-color: var(--brand-success-hover);
    box-shadow: 0 0.125rem 1rem 0px rgb(0 0 0 / 25%);
}

.interactive-buttons {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 6px;
}
.interactive-buttons .bot-list-button.is-display-only {
    cursor: default;
}
.interactive-buttons .bot-list-button.is-display-only:hover {
    background: var(--bs-green);
    box-shadow: var(--bs-box-shadow);
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .chat-time,
[data-bs-theme=dark] li.msg_wpp_render.sent-message .ack i,
[data-bs-theme=dark] li.msg_wpp_render.system-message .chat-time {
    color: rgba(255, 255, 255, 0.7);
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .status-read {
    color: #75cffc !important;
}

/* Par de tema claro, que só existia para a linha de áudio. */
[data-bs-theme=light] li.msg_wpp_render.sent-message .status-read {
    color: #50a5f1 !important;
}

[data-bs-theme=light] li.msg_wpp_render.system-message .chat-time {
    color: #ffc4dc !important;
}



.audio-meta-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
    padding: 0 4px 0 2px;
}

.audio-meta-row .chat-time-stamp {
    font-size: 11px !important;
    opacity: 0.7;
    color: var(--bs-text-muted);
}

.audio-meta-row .ack i {
    font-size: 16px;
    /* color: var(--bs-text-muted); */
}

.audio-meta-row .status-read {
    color: #50a5f1 !important;
}

.btn-download-audio {
    /* color: var(--bs-text-muted); */
    opacity: 0.7;
    padding: 0;
    font-size: 16px;
    line-height: 1;
    text-decoration: none !important;
    box-shadow: none !important;
}

.btn-download-audio:hover {
    opacity: 1;
    color: var(--bs-dark);
}

[data-bs-theme=dark] .audio-meta-row .chat-time-stamp,
[data-bs-theme=dark] .btn-download-audio {
    color: rgba(255, 255, 255, 0.7);
}

[data-bs-theme=dark] .btn-download-audio:hover {
    color: #fff;
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=dark] li.msg_wpp_render.sent-message .audio-meta-row .ack i {
    color: rgba(255, 255, 255, 0.7);
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .audio-meta-row .status-read {
    color: #75cffc !important;
}

[data-bs-theme=light] li.msg_wpp_render.sent-message .audio-meta-row .status-read {
    color: #50a5f1 !important;
}

[data-bs-theme=light] li.msg_wpp_render.system-message .audio-meta-row .chat-time-stamp {
    color: #ffc4dc !important;
}


.ctext-wrap .dropdown {
    flex-shrink: 0;
    margin-top: 2px;
}

.ctext-wrap .dropdown-toggle {
    text-decoration: none !important;
    box-shadow: none !important;
    padding: 0;
    font-size: 1.1rem;
    color: var(--bs-text-muted);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.conversation-list:hover .dropdown-toggle {
    opacity: 1;
}

.ctext-wrap .dropdown-toggle::after {
    display: none;
}

.ctext-wrap .dropdown-toggle:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

[data-bs-theme=dark] .ctext-wrap .dropdown-toggle:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

[data-bs-theme=dark] .sent-message .dropdown-toggle {
    color: var(--bs-dark);
}

[data-bs-theme=dark] .sent-message .dropdown-toggle:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 8px 12px;
    margin-bottom: 8px;
    cursor: pointer;
    opacity: 0.9;
    border-left: 4px solid var(--bs-success);
    overflow: hidden;

    max-width: 100%;
}

.quoted-owner {
    font-weight: 600;
    color: var(--bs-primary);
    font-size: 13px;
}

/* Rótulo "do grupo X" da resposta em particular: herda a cor do trecho citado. */
.quoted-group-origin {
    font-size: 11px;
    opacity: 0.8;
}

.quoted-reply-wrapper.quoted-reply-grupo {
    cursor: default;
}

.quoted-snippet {
    font-size: 14px;
    color: var(--bs-text-muted);

    white-space: normal;

    word-break: break-word;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

[data-bs-theme=dark] .quoted-reply-wrapper {
    background-color: rgba(255, 255, 255, 0.05);
    border-left: 4px solid var(--bs-success);
}

[data-bs-theme=dark] .quoted-owner {
    color: var(--bs-primary);
}

[data-bs-theme=dark] .quoted-snippet {
    color: rgba(255, 255, 255, 0.7);
}


li.msg_wpp_render.received-message .quoted-reply-wrapper {
    border-left: 4px solid #00f9b8;
}

li.msg_wpp_render.received-message .quoted-snippet {
    opacity: 0.9; 
}

li.msg_wpp_render.received-message .quoted-owner {
    color: var(--bs-white-text, #ffffff); /* Fallback para branco caso a var não exista */
}

.sent-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border-left: 4px solid var(--bs-success);
}

.sent-message .quoted-owner {
    color: var(--bs-primary);
}

.sent-message .quoted-snippet {
    color: var(--bs-text-muted);
}

[data-bs-theme=dark] .sent-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.1);
    border-left: 4px solid var(--bs-success);
}

[data-bs-theme=dark] .sent-message .quoted-owner {
    color: var(--bs-primary);
}

[data-bs-theme=dark] .sent-message .quoted-snippet {
    color: var(--bs-text-muted);
}


.reaction-picker-popper {
    background: var(--bs-light);
    border-radius: 20px;
    padding: 4px 8px;
    display: flex;
    gap: 4px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.reaction-picker-popper .emoji-btn {
    font-size: 22px;
    padding: 4px;
    border: none;
    background: transparent;
    border-radius: 8px;
    transition: transform 0.1s ease, background-color 0.15s ease;
}

.reaction-picker-popper .emoji-btn:hover {
    transform: scale(1.15);
    background-color: var(--bs-light-bg-subtle);
}

.reactions-wrapper {
    background-color: var(--bs-light);
    color: var(--bs-dark);
    border: 1px solid var(--bs-border-color);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: absolute;
    bottom: -10px;
    right: 12px;
    z-index: 2;
    display: flex;
}

.sent-message .reactions-wrapper {
    right: auto;
    left: 12px;
}

.reaction-item {
    padding: 1px 5px;
    font-size: 13px;
    cursor: pointer;
    transition: transform 0.1s ease;
}

.reaction-item:hover {
    transform: scale(1.1);
}

.reaction-item+.reaction-item {
    margin-left: -5px;
}


.chat-time {
    position: relative;
    z-index: 1;
}

.edited-badge {
    font-size: 10px;
    font-style: italic;
    opacity: 0.8;
    margin-right: 4px;
}


li.msg_wpp_render {
    transition: background-color 0.2s ease-in-out, padding-left 0.3s ease;
    border-radius: 8px;
    padding-left: 0px;
}

.conversation-list.forward-mode {
    cursor: pointer;
}

li.msg_wpp_render:has(.conversation-list.forward-mode) {
    padding: 0rem 2rem;
}

.conversation-list.forward-mode .ctext-wrap {
    transform: translateX(0);
}

li.msg_wpp_render:has(.conversation-list.forward-mode):hover {
    background-color: #6ae6c711;
    cursor: pointer;
}

li.msg_wpp_render:has(.conversation-list.forward-mode .form-check-input:checked) {
    background-color: #6ae6c720;
    cursor: pointer;
}

li.msg_wpp_render.reply-selected {
    background-color: #6ae6c720;
    transition: background-color 0.2s ease;
}

.message-selection-box {
    flex-shrink: 0;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.message-selection-box .form-check {
    padding: 0;
}

.message-selection-box .form-check-input {
    font-size: 1.25rem;
    pointer-events: none;
}

.message-selection-box .form-check-input {
    font-size: 1.25rem;
    pointer-events: none;
    border-radius: 6px;
    background-color: transparent;
    border: 2px solid var(--bs-text-muted);
    box-shadow: none !important;
    background-image: none !important;
}

.message-selection-box .form-check-input:focus {
    border-color: var(--bs-primary);
    box-shadow: none;
}

.message-selection-box .form-check-input:checked {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary) !important;

    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");

    background-image: var(--bs-form-check-bg-image) !important;
}


.dropdown-item-v.copied-feedback {
    color: var(--bs-success);
    font-weight: 500;
}

.dropdown-item-v.copied-feedback i {
    color: var(--bs-success) !important;
}

.favorite-star-icon {
    font-size: 11px;
    margin-right: 4px;
    vertical-align: middle;
    opacity: 0.9;
}

.received-message .favorite-star-icon,
.system-message .favorite-star-icon {
    color: #fff;
    opacity: 1;
}

.pinned-icon {
    font-size: 11px;
    vertical-align: middle;
    color: var(--bs-text-muted);
}

.received-message .pinned-icon,
.system-message .pinned-icon {
    color: #fff;
    opacity: 0.8;
}

[data-bs-theme=dark] .sent-message .pinned-icon {
    color: var(--bs-text-muted);
}

.system-message-wrapper {
    display: flex;
    justify-content: center;
    margin: 1rem 0;
}

.system-message-text {
    background-color: var(--bs-light-bg-subtle);
    color: var(--bs-text-muted);
    font-size: 13px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 6px;
}



.file-message-card {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 4px;
    margin-bottom: 2px;
    max-width: 300px;
}

[data-bs-theme="dark"] .file-message-card {
    background-color: rgba(255, 255, 255, 0.08);
}

.file-card-inner {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
}

[data-bs-theme="dark"] .file-card-inner {
    background-color: #2a2d31;
}

.file-icon {
    font-size: 28px;
    color: #ff5e5e;
    margin-right: 10px;
}

.file-info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-grow: 1;
}

.file-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--bs-body-color);
}

.file-meta {
    font-size: 11px;
    color: var(--bs-text-muted);
}

.btn-download-file {
    color: var(--bs-text-muted);
    border: 1px solid var(--bs-border-color);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    padding: 0;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-download-file:hover {
    background-color: rgba(0,0,0,0.05);
    color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.contact-message-card {
    width: 280px;
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: var(--bs-box-shadow);
}

[data-bs-theme="dark"] .contact-message-card {
    background-color: rgba(255, 255, 255, 0.05);
}

.contact-header {
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 12px;
}

.avatar-contact {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ced4da;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
}

.contact-name {
    font-size: 15px;
    font-weight: 500;
    color: var(--bs-body-color);
}

.contact-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding: 8px;
    text-align: center;
    box-shadow: var(--bs-box-shadow-lg);
}

[data-bs-theme="dark"] .contact-footer {
    border-top-color: rgba(255, 255, 255, 0.1);
}

.btn-contact-action {
    color: var(--bs-success);
    font-weight: 500;
    text-decoration: none;
    width: 100%;
    font-size: 14px;
    border-radius: 1rem;
}

.btn-contact-action:hover {
    color: #04956f;
}

.rounded {
    border-radius: 12px !important;
}

.cursor-pointer {
    cursor: pointer;
}

.agent-name-header {
    font-size: 12.5px;
    font-weight: 700;
    color: var(--bs-primary);
    margin-bottom: 2px;
    display: block;
    line-height: 1.2;
    opacity: 0.9;
}

/* Recebida: no claro a bolha é BRANCA — o branco fixo aqui deixava o nome
   invisível. Cor de destaque da marca no claro, branco só no escuro. */
[data-bs-theme=light] li.msg_wpp_render.received-message .agent-name-header {
    color: var(--brand-name-accent) !important;
    opacity: 1;
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .agent-name-header {
    color: #ffffff !important;
    opacity: 1;
}

[data-bs-theme=dark] .agent-name-header {
    color: var(--brand-name-accent);
}

.message-text.pt-1 {
    padding-top: 4px !important;
}

:deep(.search-highlight) {
    background-color: rgba(var(--bs-success-rgb), 0.47);
    padding: 0 1px;
    border-radius: 3px;
    font-weight: 500;
}

:deep(.chat-link) {
    color: #027eb5;
    text-decoration: underline;
    word-break: break-all;
}

:deep(.chat-link:hover) {
    color: #027eb5;
}


:deep(.chat-code) {
    font-family: monospace;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 0.9em;
}


.template-card {
    min-width: 260px;
    max-width: 320px;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 5px;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pix-style {
    background-color: #fff;
    border: 1px solid #e0f2f1;
}

.card-header-accent {
    height: 6px;
    background: linear-gradient(90deg, #32bcad, #26a69a);
    width: 100%;
}

.card-body-content {
    padding: 16px;
}

.pix-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
}

.pix-icon-brand {
    color: #32bcad;
    font-size: 20px;
}

.pix-label {
    font-weight: 700;
    color: #333;
    font-size: 15px;
    letter-spacing: -0.3px;
}

.detail-group {
    margin-bottom: 12px;
}

.detail-group label {
    font-size: 10px;
    text-transform: uppercase;
    color: #999;
    font-weight: 700;
    letter-spacing: 0.5px;
    display: block;
    margin-bottom: 2px;
}

.detail-group p {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.detail-group p.pix-corpo {
    white-space: pre-line;
    word-break: break-word;
}

.key-container {
    background: #f4f6f8;
    border-radius: 6px;
    padding: 6px 10px;
    border: 1px solid #eee;
}

.key-text {
    font-family: monospace;
    font-size: 13px;
    color: #555;
    display: block;
}

.btn-action-pix {
    width: 100%;
    background-color: #e0f2f1;
    color: #00897b;
    border: none;
    padding: 10px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-action-pix:hover {
    background-color: #b2dfdb;
}

/* === ESTILO SENHA === */
.pass-style {
    background-color: #fff;
    padding: 24px 20px;
    text-align: center;
    border: 1px solid #eee;
}

.pass-icon-circle {
    width: 48px;
    height: 48px;
    background-color: #e8eaf6;
    color: #3f51b5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin: 0 auto 12px auto;
}

.pass-title {
    font-weight: 700;
    color: #333;
    margin: 0;
    font-size: 16px;
}

.pass-desc {
    font-size: 12px;
    color: #888;
    margin-bottom: 16px;
    line-height: 1.4;
}

.code-display {
    background: #f8f9fa;
    border: 2px dashed #c5cae9;
    border-radius: 8px;
    padding: 12px;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 3px;
    color: #333;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
}

.code-display:hover {
    background: #e8eaf6;
    border-color: #3f51b5;
}

.copy-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: #999;
    opacity: 0;
    transition: opacity 0.2s;
}

.code-display:hover .copy-icon {
    opacity: 1;
}

.pass-footer {
    margin-top: 16px;
    font-size: 10px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* === DARK MODE ADJUSTMENTS === */
[data-bs-theme=dark] .pix-style,
[data-bs-theme=dark] .pass-style {
    background-color: #2a2d31;
    border-color: #3a3f44;
}

[data-bs-theme=dark] .pix-label,
[data-bs-theme=dark] .pass-title,
[data-bs-theme=dark] .detail-group p {
    color: #e9ecef;
}

[data-bs-theme=dark] .key-container {
    background-color: #32363a;
    border-color: #3a3f44;
}

[data-bs-theme=dark] .key-text {
    color: #adb5bd;
}

[data-bs-theme=dark] .btn-action-pix {
    background-color: rgba(50, 188, 173, 0.15);
    color: #32bcad;
}

[data-bs-theme=dark] .code-display {
    background-color: #32363a;
    border-color: #3f51b5;
    color: #fff;
}

[data-bs-theme=dark] .pass-icon-circle {
    background-color: rgba(63, 81, 181, 0.2);
}

.group-sender-name {
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.2;
}

[data-bs-theme=dark] .group-sender-name {
    color: var(--brand-name-accent);
}

.sticker {
    max-width: 200px;
}

.file-preview {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
}

.file-link {
    color: #007bff;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.file-link i {
    margin-right: 5px;
}

.file-caption {
    font-size: 0.9em;
    color: #6c757d;
    margin-top: 5px;
}

.location-message-card {
    width: 300px;
    background-color: rgba(0,0,0,0.03);
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 2px;
    border: 1px solid rgba(0,0,0,0.05);
}

.location-preview {
    position: relative;
    height: 180px;
    width: 100%;
}

.location-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 10;
    cursor: pointer;
}

.location-footer {
    padding: 10px 12px;
    background-color: rgba(255,255,255,0.6);
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: var(--bs-body-color);
    font-weight: 500;
}

/* Dark Mode Location */
[data-bs-theme="dark"] .location-message-card {
    background-color: rgba(255,255,255,0.05);
    border-color: rgba(255,255,255,0.1);
}
[data-bs-theme="dark"] .location-footer {
    background-color: #2a2d31;
    color: #e9ecef;
}


/* === ENQUETE (POLL) === */
.poll-message-card {
    min-width: 280px;
    max-width: 350px;
    padding: 12px;
    background-color: rgb(255 255 255 / 22%);
    border-radius: 12px;
}

.poll-question {
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 4px;
    color: var(--bs-heading-color);
}

.poll-subtitle {
    font-size: 11px;
    display: block;
    margin-bottom: 12px;
}

.poll-options-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.poll-option-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 4px;
}

.poll-checkbox {
    font-size: 20px;
    color: var(--bs-text-muted);
    opacity: 0.7;
}

.poll-bar-container {
    flex-grow: 1;
}

.poll-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
}

/* O texto da opção cede espaço para a pilha de avatares, em vez de empurrá-la
   para fora da bolha. */
.poll-opt-text {
    min-width: 0;
    overflow-wrap: anywhere;
}

.poll-opt-votes {
    font-variant-numeric: tabular-nums;
    opacity: 0.75;
}

/* Gatilho do popover. Sem fundo nem borda para não virar botão dentro da bolha:
   o que anuncia o clique são os rostos, não uma moldura. */
.poll-opt-votes-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font: inherit;
    cursor: pointer;
}

.poll-opt-votes-btn:hover .poll-opt-votes {
    opacity: 1;
    text-decoration: underline;
}

/* Pilha sobreposta, como avatar de participante em qualquer lista: ocupa pouca
   linha e já se lê como "tem gente aqui". */
.poll-voters-inline {
    display: inline-flex;
    align-items: center;
}

.poll-voter-chip {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    object-fit: cover;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: 700;
    color: #fff;
    /* Separa um rosto do outro na sobreposição. Anel ESCURO no tema claro: a
       bolha RECEBIDA é branca (`--bs-white`) e o card só põe 22% de branco por
       cima, então um anel branco sumia justamente no caso mais comum — enquete
       se recebe, raramente se manda — e os três rostos viravam um borrão. Preto
       a 18% aparece tanto no branco quanto no gradiente da bolha enviada. */
    box-shadow: 0 0 0 1.5px rgb(0 0 0 / 18%);
}

/* `AvatarField` tem `inheritAttrs: false`: a classe vai no `<img>` INTERNO, que
   é renderizado pelo filho e por isso carrega o `data-v-` DELE, não o nosso —
   `.poll-voter-chip[data-v-nosso]` nunca casa com aquele elemento. Sem esta
   regra o avatar com foto caía em `.avatar-field img[data-v-dele]{width:40px}`
   e nascia 40px numa pilha de 18px. `:deep()` atravessa o limite de escopo E
   ganha em especificidade (0,3,1 contra 0,2,1). Mesma armadilha do popper
   teleportado, do outro lado do espelho. */
.poll-voters-inline :deep(.avatar-field img) {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    object-fit: cover;
    background: none;
    box-shadow: 0 0 0 1.5px rgb(0 0 0 / 18%);
}

.poll-voters-inline > * + * {
    margin-left: -6px;
}

.poll-voter-chip-blank {
    background-color: rgb(0 0 0 / 12%);
    color: inherit;
    font-size: 10px;
}

/* O excedente cresce; o círculo de 18px não. Sem largura automática "+999"
   vazava a borda (`border-radius` não recorta nada com `overflow: visible`), e
   pôr `overflow: hidden` só trocaria o vazamento por número cortado. Vira
   pílula: mantém 18px de diâmetro em "+9" e alarga a partir daí. */
.poll-voter-chip-more {
    width: auto;
    min-width: 18px;
    padding: 0 4px;
    border-radius: 9px;
    background-color: rgb(0 0 0 / 12%);
    color: inherit;
    font-size: 8px;
    letter-spacing: -0.3px;
    white-space: nowrap;
}

/* `AvatarField` põe a classe no `<img>` interno (`inheritAttrs: false`), então o
   `div` dele fica sem regra nenhuma e é ele que participa do flex da pilha. */
.poll-voters-inline .avatar-field {
    flex-shrink: 0;
    line-height: 0;
}

/* Rodapé: total à esquerda, saída explícita à direita. */
.poll-footer-votes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding-top: 6px;
    border-top: 1px solid rgb(221 221 221 / 52%);
}

/* Cor HERDADA da bolha, não `--bs-success`. Nas marcas verdes (PROSA/GRPRO) a
   bolha enviada É um gradiente verde, e `--bs-success` em cima dela dava verde
   sobre verde (~1,9:1).

   E SEM opacidade própria: na bolha enviada o card todo herda `color:#fff` e a
   contagem ao lado já roda a `opacity: .75`; apagar este também só afundaria o
   contraste abaixo do texto que ele acompanha. O que sobra de contraste baixo
   ali é da bolha da marca, comum a todo texto do card, e não é este botão que
   resolve. O sublinhado é o que marca que isto é um controle. */
.poll-see-votes-btn {
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: none;
    font-size: 11px;
    font-weight: 600;
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
}

.poll-see-votes-btn:hover {
    text-decoration-thickness: 2px;
}

.poll-see-votes-btn i {
    font-size: 14px;
    line-height: 1;
}

/* A aparência do popover de votantes mora em `assets/css/poppers-enquete.css`:
   o popper é teleportado para fora da árvore do componente, então o atributo de
   escopo não chega nele e regra de `<style scoped>` nunca casa (mesma lição de
   `assets/css/tooltips.css`). Aqui fica só o gatilho, que é do componente. */

.poll-bar-track {
    height: 4px;
    margin-top: 4px;
    border-radius: 2px;
    background-color: rgb(0 0 0 / 12%);
    overflow: hidden;
}

.poll-bar-fill {
    height: 100%;
    border-radius: 2px;
    background-color: var(--bs-success);
    transition: width 0.25s ease;
}

.poll-total-voters {
    font-size: 11px;
    opacity: 0.75;
}

[data-bs-theme="dark"] .poll-bar-track {
    background-color: rgb(255 255 255 / 15%);
}

[data-bs-theme="dark"] .poll-voter-chip-blank,
[data-bs-theme="dark"] .poll-voter-chip-more {
    background-color: rgb(255 255 255 / 18%);
}

/* No escuro a bolha recebida é `--bs-light` (#2b2b2b): o anel preto some e quem
   separa é o claro. */
[data-bs-theme="dark"] .poll-voter-chip,
[data-bs-theme="dark"] .poll-voters-inline :deep(.avatar-field img) {
    box-shadow: 0 0 0 1.5px rgb(255 255 255 / 30%);
}

[data-bs-theme="dark"] .poll-footer-votes {
    border-top-color: rgba(255, 255, 255, 0.1);
}


[data-bs-theme="dark"] .poll-message-card {
    background-color: rgba(255,255,255,0.05);
}
[data-bs-theme="dark"] .poll-question {
    color: #fff;
}


/* === CARD DE MÚLTIPLOS CONTATOS (PREMIUM STYLE) === */
.multi-contact-card {
    background: #ffffff;
    border-radius: 18px; /* Mais arredondado = mais moderno */
    overflow: hidden;
    min-width: 250px;
    max-width: 290px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08); /* Sombra mais difusa */
    border: 1px solid rgba(0,0,0,0.06);
    display: flex;
    flex-direction: column;
    margin-bottom: 2px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.multi-contact-card:hover {
    box-shadow: 0 6px 16px rgba(0,0,0,0.12);
}

/* --- CORPO (Avatares + Texto) --- */
.multi-contact-body {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #fff;
}

/* Área dos Avatares */
.avatars-area {
    flex-shrink: 0;
}

.avatar-stack-wrapper {
    display: flex;
    align-items: center;
    padding-left: 8px; /* Espaço para o primeiro avatar não cortar */
}

.stack-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid #fff; /* Borda branca grossa para separar visualmente */
    overflow: hidden;
    background-color: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    margin-left: -14px; /* Sobreposição agressiva */
    position: relative;
    transition: transform 0.2s ease;
}

/* Efeito hover sutil nos avatares */
.multi-contact-card:hover .stack-avatar:nth-child(1) { transform: translateX(0); }
.multi-contact-card:hover .stack-avatar:nth-child(2) { transform: translateX(2px); }
.multi-contact-card:hover .stack-avatar:nth-child(3) { transform: translateX(4px); }
.multi-contact-card:hover .stack-avatar.counter { transform: translateX(6px); }

.stack-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Iniciais e Contador */
.stack-avatar.initials,
.stack-avatar.counter {
    font-size: 13px;
    font-weight: 700;
    color: #5e6c84;
    letter-spacing: -0.5px;
}

.stack-avatar.counter {
    background-color: #e2e8f0;
    color: #475569;
    z-index: 0;
}

/* Estilo para avatar com gradiente fallback */
.stack-avatar:not(.has-image):not(.counter) {
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
    color: #0284c7;
}

/* --- TEXTOS --- */
.contact-info-col {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
}

.primary-name {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b; /* Cinza bem escuro, quase preto */
    margin: 0;
    line-height: 1.2;
}

.secondary-text {
    font-size: 12px;
    color: #64748b; /* Slate 500 */
    margin-top: 2px;
    font-weight: 500;
}

/* --- RODAPÉ (BOTÃO) --- */
.multi-contact-footer {
    background-color: #f8fafc; /* Fundo levemente cinza */
    border-top: 1px solid #f1f5f9;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: background-color 0.2s;
}

.multi-contact-footer:hover {
    background-color: #f1f5f9;
}

.btn-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--bs-primary); /* Usa cor do tema */
}

.arrow-icon {
    font-size: 16px;
    color: var(--bs-primary);
    opacity: 0.7;
    transition: transform 0.2s;
}

.multi-contact-footer:hover .arrow-icon {
    transform: translateX(3px);
    opacity: 1;
}

/* === DARK MODE === */
[data-bs-theme="dark"] .multi-contact-card {
    background: #1e293b; /* Slate 800 */
    border-color: rgba(255,255,255,0.05);
}

[data-bs-theme="dark"] .multi-contact-body,
[data-bs-theme="dark"] .multi-contact-footer {
    background-color: transparent;
}

[data-bs-theme="dark"] .multi-contact-footer {
    background-color: rgba(0,0,0,0.15);
    border-top-color: rgba(255,255,255,0.08);
}

[data-bs-theme="dark"] .stack-avatar {
    border-color: #1e293b;
    background-color: #334155;
}

[data-bs-theme="dark"] .stack-avatar.initials,
[data-bs-theme="dark"] .stack-avatar.counter {
    color: #cbd5e1;
    background-color: #334155;
}

[data-bs-theme="dark"] .stack-avatar:not(.has-image):not(.counter) {
    background: linear-gradient(135deg, #334155 0%, #475569 100%);
    color: #e2e8f0;
}

[data-bs-theme="dark"] .primary-name { color: #f1f5f9; }
[data-bs-theme="dark"] .secondary-text { color: #94a3b8; }

/* === CARD DE CONTATO ÚNICO (PREMIUM STYLE) === */
.contact-card-premium {
    background: #ffffff;
    border-radius: 18px;
    overflow: hidden;
    min-width: 250px;
    max-width: 290px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    border: 1px solid rgba(0,0,0,0.06);
    display: flex;
    flex-direction: column;
    margin-bottom: 2px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    /* Importante: Reseta cores herdadas do balão */
    color: initial;
}

.contact-card-premium:hover {
    box-shadow: 0 6px 16px rgba(0,0,0,0.12);
    transform: translateY(-1px);
}

/* --- ÁREA COMUM (CORPO) --- */
.premium-card-body {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #fff;
}

/* Avatar Único (Maior que o da pilha) */
.single-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%); /* Azul suave default */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0284c7;
    border: 1px solid rgba(0,0,0,0.04);
    flex-shrink: 0;
}

.single-avatar .initials {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.5px;
}

/* Tipografia (Reutilizando classes do Multi, mas garantindo especificidade) */
.contact-card-premium .primary-name {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    line-height: 1.2;
}

.contact-card-premium .secondary-text {
    font-size: 13px; /* Ligeiramente maior para número de telefone */
    color: #64748b;
    margin-top: 3px;
    font-weight: 500;
    display: block;
}

/* --- RODAPÉ (FOOTER) --- */
.premium-card-footer {
    background-color: #f8fafc;
    border-top: 1px solid #f1f5f9;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: background-color 0.2s;
}

.premium-card-footer:hover {
    background-color: #f1f5f9;
}

.premium-card-footer .btn-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--bs-primary);
}

.premium-card-footer .action-icon {
    font-size: 16px;
    color: var(--bs-primary);
    opacity: 0.8;
    transition: transform 0.2s;
}

.premium-card-footer:hover .action-icon {
    transform: scale(1.1);
    opacity: 1;
}

/* === DARK MODE === */
[data-bs-theme="dark"] .contact-card-premium {
    background: #1e293b; /* Slate 800 */
    border-color: rgba(255,255,255,0.05);
}

[data-bs-theme="dark"] .premium-card-body,
[data-bs-theme="dark"] .premium-card-footer {
    background-color: transparent;
}

[data-bs-theme="dark"] .premium-card-footer {
    background-color: rgba(0,0,0,0.15);
    border-top-color: rgba(255,255,255,0.08);
}

[data-bs-theme="dark"] .single-avatar {
    background: linear-gradient(135deg, #334155 0%, #475569 100%);
    color: #e2e8f0;
    border-color: rgba(255,255,255,0.1);
}

[data-bs-theme="dark"] .contact-card-premium .primary-name { color: #f1f5f9; }
[data-bs-theme="dark"] .contact-card-premium .secondary-text { color: #94a3b8; }

/* === CONVITE DE GRUPO === */
.group-invite-card {
    border-radius: 16px;
    overflow: hidden;
    min-width: 250px;
    max-width: 290px;
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(0,0,0,0.08);
    border: 1px solid rgba(0,0,0,0.06);
    margin-bottom: 2px;
}

.gi-header {
    background: linear-gradient(135deg, #00a884 0%, #008069 100%);
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.gi-icon-wrap {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: rgba(255,255,255,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.gi-icon {
    font-size: 22px;
    color: #ffffff;
}

.gi-header-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
}

.gi-label {
    font-size: 11px;
    font-weight: 600;
    color: rgba(255,255,255,0.75);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.gi-group-name {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    white-space: normal;
    line-height: 1.3;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.gi-body {
    padding: 12px 16px 8px;
}

.gi-caption {
    font-size: 13px;
    color: #374151;
    margin: 0;
    line-height: 1.4;
}

.gi-footer {
    padding: 10px 16px;
    border-top: 1px solid #f1f5f9;
    background: #f8fafc;
    display: flex;
    align-items: flex-start;
    gap: 6px;
}

.gi-info-icon {
    font-size: 14px;
    color: #94a3b8;
    flex-shrink: 0;
    margin-top: 1px;
}

.gi-info-text {
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.4;
    font-style: italic;
}

/* dark mode */
[data-bs-theme="dark"] .group-invite-card {
    background: #1e293b;
    border-color: rgba(255,255,255,0.05);
}

[data-bs-theme="dark"] .gi-header {
    background: linear-gradient(135deg, #065f46 0%, #064e3b 100%);
}

[data-bs-theme="dark"] .gi-body .gi-caption {
    color: #cbd5e1;
}

[data-bs-theme="dark"] .gi-footer {
    background: rgba(0,0,0,0.2);
    border-top-color: rgba(255,255,255,0.07);
}

/* ---- pedido do catálogo ---- */
.catalog-order-card {
    border-radius: 12px;
    overflow: hidden;
    min-width: 250px;
    max-width: 290px;
    background: #f8fafc;
    border: 1px solid rgba(0,0,0,0.06);
    margin-bottom: 2px;
}

.co-media {
    position: relative;
    height: 160px;
    background: #0f172a;
}

.co-media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.co-surface {
    position: absolute;
    top: 8px;
    left: 8px;
    background: rgba(0,0,0,0.62);
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding: 3px 8px;
    border-radius: 20px;
}

.co-body {
    padding: 12px 14px;
}

.co-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    color: #00a884;
    margin-bottom: 4px;
}

.co-title {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 6px;
    line-height: 1.3;
    white-space: normal;
}

.co-meta {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 9px;
}

.co-price {
    font-size: 17px;
    font-weight: 800;
    color: #0f172a;
}

.co-dot,
.co-qty {
    font-size: 12px;
    color: #94a3b8;
}

.co-itens {
    list-style: none;
    margin: 0 0 9px;
    padding: 0;
    border-top: 1px solid #e9eef4;
}

.co-item {
    display: flex;
    align-items: baseline;
    gap: 6px;
    padding: 5px 0 0;
    font-size: 12px;
    line-height: 1.3;
}

.co-item-sku {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    color: #64748b;
}

.co-item-qtd {
    flex-shrink: 0;
    color: #94a3b8;
}

.co-item-preco {
    flex-shrink: 0;
    font-weight: 600;
    color: #0f172a;
}

.co-note {
    font-size: 13px;
    color: #374151;
    margin: 0 0 9px;
    line-height: 1.4;
}

.co-status {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 9px;
    border-radius: 20px;
    background: rgba(245,158,11,0.14);
    color: #b45309;
}

.co-footer {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    padding: 9px 14px;
    border-top: 1px solid #e9eef4;
    background: #ffffff;
}

.co-info-icon {
    font-size: 14px;
    color: #94a3b8;
    flex-shrink: 0;
    margin-top: 1px;
}

.co-info-text {
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.4;
    font-style: italic;
}

[data-bs-theme="dark"] .catalog-order-card {
    background: rgba(0,0,0,0.22);
    border-color: rgba(255,255,255,0.06);
}

[data-bs-theme="dark"] .co-label {
    color: #34d399;
}

[data-bs-theme="dark"] .co-title,
[data-bs-theme="dark"] .co-price {
    color: #f1f5f9;
}

[data-bs-theme="dark"] .co-note {
    color: #cbd5e1;
}

[data-bs-theme="dark"] .co-itens {
    border-top-color: rgba(255,255,255,0.08);
}

[data-bs-theme="dark"] .co-item-preco {
    color: #f1f5f9;
}

[data-bs-theme="dark"] .co-status {
    background: rgba(245,158,11,0.16);
    color: #fbbf24;
}

[data-bs-theme="dark"] .co-footer {
    background: rgba(0,0,0,0.18);
    border-top-color: rgba(255,255,255,0.06);
}

[data-bs-theme="dark"] .co-info-text,
[data-bs-theme="dark"] .co-info-icon {
    color: #64748b;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content {
    background: #f8f9fa91 !important;
    background-image: none !important;
    border: 1px solid #e9ecef !important;
    border-left: 4px solid #b0b0b0 !important;
    color: #495057 !important;
    font-style: italic !important;
}
li.msg_wpp_render.received-message .deleted-notice {
    font-weight: 600;
    font-size: 12px;
    text-transform: none;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    margin-bottom: 6px;
    padding-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.ctext-wrap-content.deleted-content {
    font-style: italic !important;
}
.deleted-content {
    background-image: none !important;
    background-color: #f8f9fa91 !important;
    background: linear-gradient(to bottom, #ffffff47, #fafafa) !important;

    border: 1px solid rgba(0,0,0,0.06) !important;
    border-left: 4px solid #b0b0b0 !important;

    box-shadow: 0 2px 4px rgba(0,0,0,0.03) !important;
    color: #6c757d !important;

    transition: all 0.3s ease;
    overflow: hidden;
}

.deleted-notice {
    font-size: 12px;
    font-weight: 600;
    color: #878a8c;
    text-transform: none;
    letter-spacing: normal;

    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(0,0,0,0.05);

    display: flex;
    align-items: center;
    gap: 6px;
}

.deleted-notice i {
    font-size: 14px;
    color: #999;
}

.deleted-content:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;
    border-left-color: #999 !important;
    background-color: #fff !important;
}

.opacity-50 {
    opacity: 0.6;
    filter: grayscale(100%);
    transition: all 0.3s ease;
}

.deleted-content:hover .opacity-50 {
    opacity: 0.85;
    filter: grayscale(0%);
}

[data-bs-theme=dark] .deleted-content {
    background: #222529 !important; /* Fundo escuro sólido */
    border-color: rgba(255,255,255,0.05) !important;
    border-left-color: #4a4a4a !important;
    color: #adb5bd !important;
}

[data-bs-theme=dark] .deleted-notice {
    color: #888;
    border-bottom-color: rgba(255,255,255,0.08);
}

li.msg_wpp_render.received-message .deleted-notice i {
    font-size: 14px !important;
    color: #adb5bd !important;
}

.deleted-content .opacity-50 {
    opacity: 0.5;
    filter: grayscale(100%);
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content {
    background: var(--bs-light) !important;
    background-image: none !important;
    border: 1px solid rgba(255,255,255,0.05) !important;
    border-left: 4px solid #4a4a4a !important;
    color: #ced4da !important;
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .deleted-notice {
    color: #adb5bd !important;
    border-bottom-color: rgba(255,255,255,0.1);
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .chat-time,
[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .chat-time span,
[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .align-middle {
    color: var(--bs-secondary-color);
    font-style: italic;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .pinned-icon {
    color: #6c757d !important;
}


.image-message {
    height: auto;
    position: relative;
    width: 350px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
}

.image-message.sticker-wrapper {
    width: auto !important;
    background-color: transparent !important;
}

.chat-media-fixed {
    height: 350px;
    width: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 8px !important;
    min-height: 100px;
    background-color: #f0f2f5; /* Cor de fundo cinza claro enquanto carrega (placeholder) */
    transition: opacity 0.3s ease-in;
}

img[loading="lazy"] {
    display: block; /* Garante que o navegador respeite as dimensões de bloco */
}

.message-text.pt-1 {
    padding: 8px 4px 4px 4px !important;
    width: 100%;
    box-sizing: border-box;
}

.chat-media-fixed.sticker {
    height: 160px !important;
    width: 160px !important;
    object-fit: contain !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

.image-message:hover .chat-media-fixed:not(.sticker) {
    opacity: 0.95;
    transition: opacity 0.2s ease;
}

/* Adicione isso ao final do seu style */

:deep(.mention-highlight) {
    color: var(--bs-success);
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s;
}

:deep(.mention-highlight:hover) {
    opacity: 0.8;
    text-decoration: underline;
}

[data-bs-theme="dark"] :deep(.mention-highlight) {
    color: var(--bs-success);
}

.group-chat-avatar-container {
    display: flex;
    align-items: flex-end;
    margin-right: 8px;
    padding-bottom: 2px;
    z-index: 1;
}

.group-avatar-img {
    width: 32px;
    height: 32px;
    object-fit: cover;

    border-width: 2px; /* pra borda */
    border-style: solid; /* pra borda */

    background: var(--bs-sidebar-bg);
    padding: 1px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

/* .group-avatar-img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border: 1px solid rgba(0,0,0,0.05);
    background-color: #fff;
} */

li.msg_wpp_render.received-message {
    align-items: flex-end;
}

:deep(.text-line-clamp) {
    display: -webkit-box;
    -webkit-line-clamp: 10;
    line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

:deep(.btn-read-more) {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: transparent;
    border: none;
    color: #027eb5;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 0 0 0;
    cursor: pointer;
    transition: opacity 0.15s;
    line-height: 1;
    pointer-events: all;
}

:deep(.btn-read-more:hover) {
    opacity: 0.75;
    text-decoration: underline;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message :deep(.chat-link) {
    color: #84ffdf !important; /* Cor solicitada para alto contraste no gradiente */
    text-decoration: underline;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message :deep(.chat-link:hover) {
    color: #ffffff !important;
}

[data-bs-theme="dark"] li.msg_wpp_render.received-message :deep(.chat-link) {
    color: #68b8ff !important; /* Cor azul claro solicitada */
    text-decoration: underline;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .group-sender-name {
    color: var(--brand-name-accent) !important;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content :deep(.chat-link) {
    color: #027eb5 !important;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .group-sender-name i {
    color: var(--brand-name-accent) !important;
}

[data-bs-theme="dark"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .group-sender-name {
    color: var(--brand-name-accent) !important;
}

[data-bs-theme="dark"] :deep(.btn-read-more) {
    color: #53bdeb;
}

.media-grid-container {
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    background-color: transparent;
    max-width: 330px;
}

.media-grid-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2px;
    width: 100%;
}

.grid-item {
    position: relative;
    width: 100%;
    height: 120px;
    cursor: pointer;
    overflow: hidden;
}

.grid-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
}

.grid-item:hover .grid-img {
    transform: scale(1.03);
    filter: brightness(0.9);
}

.grid-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 2rem;
    font-weight: 500;
    backdrop-filter: blur(2px);
}

.grid-item:first-child { border-top-left-radius: 12px; }
.grid-item:nth-child(2) { border-top-right-radius: 12px; }
.grid-item:nth-child(3) { border-bottom-left-radius: 12px; }
.grid-item:nth-child(4) { border-bottom-right-radius: 12px; }

.media-grid-wrapper:has(.grid-item:nth-child(3):last-child) .grid-item:nth-child(3) {
    border-bottom-right-radius: 12px;
}

.text-shadow {
    text-shadow: 0 1px 2px rgba(0,0,0,0.8);
}

.cursor-pointer {
    cursor: pointer;
}

.group-avatar-img:hover {
    filter: brightness(0.9);
    transform: scale(1.05);
    transition: transform 0.2s ease;
}

.media-loading-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(2px);
    transition: opacity 0.3s;
}

.file-loading-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255, 255, 255, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(2px);
    transition: opacity 0.3s;
}

[data-bs-theme="dark"] .file-loading-overlay {
    background: rgba(0, 0, 0, 0.65);
}

.event-avatar {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    color: #059669;
    font-size: 24px;
    border-color: #a7f3d0;
}

[data-bs-theme="dark"] .event-avatar {
    background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
    color: #34d399;
    border-color: rgba(255,255,255,0.08);
}

/* Estilos modernos para overlays de estado (Loading e Erro) */
.media-state-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(3px);
    transition: all 0.3s ease;
}

.media-state-overlay.is-error {
    background: rgba(220, 53, 69, 0.7); /* Vermelho translúcido */
    cursor: pointer;
}

.media-state-overlay.is-error:hover {
    background: rgba(220, 53, 69, 0.85);
}

.error-action-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: white;
}

.retry-btn-modern {
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid white;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    transition: transform 0.2s;
}

.media-state-overlay.is-error:hover .retry-btn-modern {
    transform: rotate(45deg); /* Efeito sutil de girar ao passar o mouse */
}

.error-text {
    font-size: 13px;
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0,0,0,0.5);
    text-align: center;
}

/* Documentos */
.file-message-card.border-danger {
    border: 1px solid #dc3545 !important;
}

.file-state-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(2px);
}

[data-bs-theme="dark"] .file-state-overlay {
    background: rgba(30, 30, 30, 0.85);
}

.file-state-overlay.is-error {
    background: rgba(255, 235, 238, 0.95);
    cursor: pointer;
}

[data-bs-theme="dark"] .file-state-overlay.is-error {
    background: rgba(60, 20, 20, 0.95);
}

.error-action-content.file-error {
    flex-direction: row;
}
.error-action-content.file-error .error-text {
    text-shadow: none;
}

/* Overlay Moderno Geral */
.modern-state-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px; /* Acompanha a borda do seu card */
    z-index: 10;
    backdrop-filter: blur(2px);
    transition: all 0.25s ease;
}

/* Estado Vermelho Fofinho (Erro) */
.modern-state-overlay.is-failed {
    background: rgba(220, 53, 69, 0.75); /* Danger Bootstrap com opacidade */
    cursor: pointer;
}

.modern-state-overlay.is-failed:hover {
    background: rgba(220, 53, 69, 0.85);
}

.failed-action-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 10px;
}

.retry-circle {
    background: rgba(255, 255, 255, 0.25);
    border: 2px solid rgba(255, 255, 255, 0.8);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modern-state-overlay.is-failed:hover .retry-circle {
    transform: scale(1.1) rotate(45deg); /* Efeito tátil muito satisfatório */
}

.failed-text {
    color: white;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    line-height: 1.2;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

/* --- ESTADO DE ERRO (FALHA NO ENVIO DO ARQUIVO) --- */
.file-message-card.is-failed-card {
    background-color: rgba(220, 53, 69, 0.04) !important; /* Fundo rosinha beeeem sutil */
    border: 1px solid rgba(220, 53, 69, 0.3) !important; /* Borda vermelha suave */
}

[data-bs-theme="dark"] .file-message-card.is-failed-card {
    background-color: rgba(220, 53, 69, 0.08) !important;
    border-color: rgba(220, 53, 69, 0.4) !important;
}

/* --- BOTÃO DE REENVIAR (RETRY) COM ANIMAÇÃO EFEITO WHATSAPP --- */
.retry-btn-modern {
    background-color: rgba(220, 53, 69, 0.1);
    color: #dc3545;
    border: none;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s ease;
}

.retry-btn-modern:hover {
    background-color: #dc3545;
    color: white;
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.25);
}

.retry-btn-modern i {
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Gira a setinha quando passa o mouse */
.retry-btn-modern:hover i {
    transform: rotate(180deg);
}

/* Classes utilitárias do design */
.transition-all { transition: all 0.3s ease; }
.border-danger-subtle { border-color: rgba(220, 53, 69, 0.2) !important; }
.bg-danger-subtle { background-color: rgba(220, 53, 69, 0.1) !important; }
.bg-primary-subtle { background-color: rgba(13, 110, 253, 0.1) !important; }

/* --- ESTADO DE ERRO (FALHA NO ENVIO GERAL) --- */
.ctext-wrap-content.is-failed-message {
    background-color: rgb(254 241 241 / 74%) !important;
}

[data-bs-theme="dark"] .ctext-wrap-content.is-failed-message {
    background-color: rgba(220, 53, 69, 0.15) !important;
}

.text-failed-retry {
    display: inline-flex;
    align-items: center;
    color: #dc3545;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 8px;
    padding: 6px 10px;
    border-radius: 6px;
    background: rgba(220, 53, 69, 0.1);
    transition: all 0.2s ease;
    border: 1px solid rgba(220, 53, 69, 0.2);
}

.text-failed-retry:hover {
    background: rgba(220, 53, 69, 0.2);
    transform: translateY(-1px);
}

@media (max-width: 991.98px) {
    li.msg_wpp_render .conversation-list .ctext-wrap .ctext-wrap-content {
        max-width: 85vw !important; 
    }

    .image-message {
        width: 100%;
        max-width: 75vw; /* Mídias um pouco mais contidas */
    }

    .chat-media-fixed {
        height: auto; 
        max-height: 250px; /* Reduz a altura das imagens no celular */
    }

    li.msg_wpp_render {
        padding-right: 10px !important; 
    }
}

/* LIGHT THEME AUXILIARES */
[data-bs-theme=light] li.msg_wpp_render.sent-message .chat-time,
[data-bs-theme=light] li.msg_wpp_render.sent-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=light] li.msg_wpp_render.sent-message .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.sent-message .pinned-icon {
    color: rgba(255, 255, 255, 0.9) !important;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .chat-time,
[data-bs-theme=light] li.msg_wpp_render.received-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=light] li.msg_wpp_render.received-message .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.received-message .pinned-icon {
    color: var(--bs-text-muted) !important;
}

/* DARK THEME AUXILIARES */
/*
 * `:not(.status-read)` é obrigatório: com `!important` E um seletor de elemento
 * a mais que `[data-bs-theme=dark] … .status-read` (0,5,2 contra 0,5,1), este
 * cinza vencia o azul da mensagem LIDA — e ainda por ordem, por vir 2000 linhas
 * depois. O check duplo aparecia cinza, indistinguível de "entregue".
 * A linha de áudio nunca teve o bug porque a regra equivalente dela
 * (`.audio-meta-row .ack i`) não usa `!important`.
 */
[data-bs-theme=dark] li.msg_wpp_render.sent-message .chat-time,
[data-bs-theme=dark] li.msg_wpp_render.sent-message .ack i:not(.status-read) {
    color: rgba(255, 255, 255, 0.7) !important;
}
[data-bs-theme=dark] li.msg_wpp_render.received-message .chat-time {
    color: var(--bs-text-muted) !important;
}

/* LINKS E BOTÃO "LER MAIS" */
[data-bs-theme=light] li.msg_wpp_render.sent-message :deep(.chat-link) { color: #84ffdf !important; text-decoration: underline; }
[data-bs-theme=light] li.msg_wpp_render.sent-message :deep(.chat-link:hover) { color: #68c3ab !important; }
[data-bs-theme=dark] li.msg_wpp_render.sent-message :deep(.chat-link) { color: #68b8ff !important; text-decoration: underline; }
[data-bs-theme=dark] li.msg_wpp_render.sent-message :deep(.chat-link:hover) { color: #249ccf !important; }

[data-bs-theme=light] li.msg_wpp_render.received-message :deep(.chat-link) { color: #027eb5 !important; text-decoration: underline; }
[data-bs-theme=light] li.msg_wpp_render.received-message :deep(.chat-link:hover) { color: #027eb5 !important; }
[data-bs-theme=dark] li.msg_wpp_render.received-message :deep(.chat-link) { color: #53bdeb !important; text-decoration: underline; }

[data-bs-theme="light"] li.msg_wpp_render.sent-message :deep(.btn-read-more) { color: rgba(255,255,255,0.9); text-shadow: 0 1px 1px rgba(0,0,0,0.15); }
[data-bs-theme="dark"] li.msg_wpp_render.sent-message :deep(.btn-read-more) { color: rgba(255,255,255,0.85); }
[data-bs-theme="light"] li.msg_wpp_render.received-message :deep(.btn-read-more) { color: #027eb5; }
[data-bs-theme="dark"] li.msg_wpp_render.received-message :deep(.btn-read-more) { color: #53bdeb; }

/* CORES DOS NOMES */
li.msg_wpp_render.sent-message .agent-name-header,
li.msg_wpp_render.sent-message .group-sender-name {
    color: #ffffff !important;
    opacity: 1;
}

/* CORES DOS QUOTES (MENSAGENS RESPONDIDAS) */
.sent-message .quoted-reply-wrapper {
    background-color: rgb(255 255 255 / 24%);
    border-left: 4px solid #00f9b8;
}
.sent-message .quoted-owner { color: #ffffff; }
.sent-message .quoted-snippet { color: #ffffff; opacity: 0.9; }

.received-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border-left: 4px solid var(--bs-success);
}
.received-message .quoted-owner { color: var(--bs-primary); }
.received-message .quoted-snippet { color: var(--bs-text-muted); }

[data-bs-theme=dark] .sent-message .quoted-reply-wrapper {
    background-color: rgba(255, 255, 255, 0.15);
    border-left: 4px solid #00f9b8;
}
[data-bs-theme=dark] .sent-message .quoted-owner { color: #ffffff; }
[data-bs-theme=dark] .sent-message .quoted-snippet { color: rgba(255, 255, 255, 0.85); }

[data-bs-theme=dark] .received-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.1);
    border-left: 4px solid var(--bs-success);
}
[data-bs-theme=dark] .received-message .quoted-owner { color: var(--bs-primary); }
[data-bs-theme=dark] .received-message .quoted-snippet { color: var(--bs-text-muted); }

/* --- MÍDIA PERDIDA --- */
.media-perdida-card {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.08);
    color: #8a9ba8;
    font-size: 13px;
    font-style: italic;
    min-width: 180px;
}

.media-perdida-icon {
    font-size: 18px;
    color: #b0bec5;
    flex-shrink: 0;
}

.media-perdida-text {
    line-height: 1.3;
}

[data-bs-theme=dark] .media-perdida-card {
    background-color: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.08);
    color: #78909c;
}

[data-bs-theme=dark] .media-perdida-icon {
    color: #607d8b;
}

li.msg_wpp_render.sent-message .media-perdida-card {
    background-color: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.8);
}

li.msg_wpp_render.sent-message .media-perdida-icon {
    color: rgba(255, 255, 255, 0.6);
}

/* --- VISUALIZAÇÃO ÚNICA (reusa card de mídia perdida, ícone próprio) --- */
.view-once-card .media-perdida-icon {
    color: #7e57c2;
}

[data-bs-theme=dark] .view-once-card .media-perdida-icon {
    color: #b39ddb;
}

/* --- TIPO NÃO SUPORTADO (mesmo card, tom de aviso) --- */
.nao-suportada-card .media-perdida-icon {
    color: #b54708;
}

[data-bs-theme=dark] .nao-suportada-card .media-perdida-icon {
    color: #f79009;
}

/* === ÍCONE DE ERRO DE ENVIO (ESTILO WHATSAPP) === */
.failed-msg-error-btn {
    align-self: center;
    background: none;
    border: none;
    padding: 0 2px;
    cursor: pointer;
    color: #dc3545;
    font-size: 22px;
    line-height: 1;
    flex-shrink: 0;
    margin-left: 4px;
    transition: transform 0.15s ease, opacity 0.15s ease;
    opacity: 0.9;
}

.failed-msg-error-btn:hover {
    transform: scale(1.1);
    opacity: 1;
}

.failed-msg-modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}

.failed-msg-modal {
    background: var(--bs-body-bg);
    color: var(--bs-body-color);
    border: 1px solid var(--bs-border-color);
    border-radius: 12px;
    padding: 24px 20px 16px;
    min-width: 280px;
    max-width: 340px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.failed-msg-modal__msg {
    font-size: 15px;
    color: var(--bs-body-color);
    margin: 0 0 20px 0;
    line-height: 1.4;
}

.failed-msg-modal__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.failed-msg-modal__cancel {
    background: none;
    border: none;
    color: var(--bs-secondary-color);
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    cursor: pointer;
    border-radius: 8px;
    transition: background 0.15s;
}

.failed-msg-modal__cancel:hover {
    background: var(--bs-secondary-bg);
    color: var(--bs-body-color);
}

.failed-msg-modal__retry {
    background: #00a884;
    border: none;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: 8px 20px;
    border-radius: 20px;
    cursor: pointer;
    transition: background 0.15s;
}

.failed-msg-modal__retry:hover {
    background: #019374;
}

.status-reply-badge {
    display: flex;
    align-items: center;
    gap: 6px;

    font-size: 12px;
    font-weight: 500;
    font-style: italic;
    color: #6c757d;

    margin-bottom: 8px;
    padding: 4px 8px;

    background-color: #f8f9fa91;
    background: linear-gradient(to bottom, #ffffff47, #fafafa);
    border: 1px solid rgba(0,0,0,0.06);
    border-left: 4px solid #b0b0b0;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);

    transition: all 0.3s ease;
}

.status-reply-badge i {
    font-size: 14px;
    color: #b0b0b0;
}

[data-bs-theme=dark] .status-reply-badge {
    background: #222529;
    border-color: rgba(255,255,255,0.05);
    border-left-color: #4a4a4a;
    color: #adb5bd;
}

[data-bs-theme=dark] .status-reply-badge i {
    color: #666;
}

li.msg_wpp_render.sent-message .status-reply-badge {
    background: rgba(255,255,255,0.1);
    border-color: rgba(255,255,255,0.1);
    border-left-color: rgba(255,255,255,0.4);
    color: rgba(255,255,255,0.7);
}

li.msg_wpp_render.sent-message .status-reply-badge i {
    color: rgba(255,255,255,0.5);
}

/* Card do anúncio CTWA — acima da bolha, no espírito do card que o próprio
   WhatsApp Business mostra para lead de anúncio. */
.ad-card {
    display: flex;
    gap: 10px;
    align-items: flex-start;

    /* Acompanha a largura da bolha em vez de ficar mais estreito que o texto
       logo abaixo. `contain: inline-size` zera a contribuição do texto do anúncio
       para a largura da bolha (que é inline-block, dimensionada pelo conteúdo) —
       sem isso o corpo do criativo, mesmo cortado em 3 linhas, empurra QUALQUER
       bolha de lead para os 550px do máximo: line-clamp corta a exibição, não a
       largura max-content. `min-width` é o piso para o card que vem sozinho, que
       com a contenção não teria largura própria nenhuma. */
    width: 100%;
    /* Piso em px, não em `min()`/%: percentual em min-width vira 0 na hora de
       dimensionar a bolha e o card colapsaria. 240px cabe na bolha do celular
       (85vw) até ~300px de viewport. */
    min-width: 240px;
    contain: inline-size;
    box-sizing: border-box;
    margin-bottom: 8px;
    padding: 8px;

    border: 1px solid rgba(0,0,0,0.06);
    border-left: 3px solid #c13584; /* gradiente do Instagram não cabe em borda */
    border-radius: 8px;
    background: linear-gradient(to bottom, #ffffff47, #fafafa);

    text-decoration: none;
    color: inherit;
    overflow: hidden;
}

.ad-card-clickable {
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease;
}

.ad-card-clickable:hover {
    background: rgba(193, 53, 132, 0.06);
    border-color: rgba(193, 53, 132, 0.25);
}

.ad-card-thumb {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 6px;
    background: rgba(0,0,0,0.04);
}

.ad-card-thumb-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #c13584;
}

.ad-card-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}

.ad-card-source {
    display: flex;
    align-items: center;
    gap: 4px;

    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #c13584;

    /* O rótulo tem de caber numa linha: quebrado em duas ("REEL / DO
       INSTAGRAM") o cartão fica torto e o ícone de link desce junto. Se não
       couber, corta com reticências em vez de quebrar. */
    flex-wrap: nowrap;
    min-width: 0;
}

.ad-card-source > span:first-of-type {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ad-card-contagem,
.selo-contagem {
    flex-shrink: 0;
    white-space: nowrap;
    padding: 0 5px;
    border-radius: 8px;
    background: rgba(193, 53, 132, 0.12);
    font-size: 10px;
    letter-spacing: 0;
}

.ad-card-link-icon {
    margin-left: auto;
    opacity: 0.55;
    font-size: 12px;
}

.ad-card-clickable:hover .ad-card-link-icon {
    opacity: 1;
}

.ad-card-title {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    color: #333;
    /* Título de criativo é texto livre e pode ser longo — corta em 2 linhas;
       o texto inteiro fica no `title` do card. */
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.ad-card-text {
    font-size: 12px;
    line-height: 1.35;
    color: #6c757d;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

[data-bs-theme=dark] .ad-card {
    background: #222529;
    border-color: rgba(255,255,255,0.05);
    border-left-color: #e1306c;
}

[data-bs-theme=dark] .ad-card-title {
    color: #dee2e6;
}

[data-bs-theme=dark] .ad-card-text {
    color: #adb5bd;
}

[data-bs-theme=dark] .ad-card-source,
[data-bs-theme=dark] .ad-card-thumb-empty {
    color: #e1306c;
}

[data-bs-theme=dark] .ad-card-thumb {
    background: rgba(255,255,255,0.06);
}

[data-bs-theme=dark] .ad-card-clickable:hover {
    background: #2a2e33;
    border-color: rgba(225, 48, 108, 0.35);
}

li.msg_wpp_render.sent-message .ad-card {
    background: rgba(255,255,255,0.1);
    border-color: rgba(255,255,255,0.1);
    border-left-color: rgba(255,255,255,0.4);
}

li.msg_wpp_render.sent-message .ad-card-source,
li.msg_wpp_render.sent-message .ad-card-title {
    color: #fff;
}

li.msg_wpp_render.sent-message .ad-card-text {
    color: rgba(255,255,255,0.7);
}


/* Mídia pendente (reparo assíncrono no servidor) */
.midia-pendente {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-width: 280px;
}
.midia-pendente__visual {
    position: relative;
    min-width: 220px;
    min-height: 140px;
    border-radius: 8px;
    overflow: hidden;
    background: var(--bs-secondary-bg, rgba(0, 0, 0, 0.08));
}
.midia-pendente--audio .midia-pendente__visual {
    min-height: 48px;
}
.midia-pendente__miniatura {
    width: 100%;
    height: 100%;
    min-height: 140px;
    object-fit: cover;
    filter: blur(2px);
}
.midia-pendente__carregando {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 0.85rem;
    color: var(--bs-body-color, #333);
    background: rgba(255, 255, 255, 0.45);
}
.midia-pendente__legenda {
    white-space: pre-wrap;
    word-break: break-word;
}
</style>
